export default {translation: {
  // ATL-970: a failed Supabase read is no longer indistinguishable from an empty collection, so
  // it now has something to say to the merchant.
  dataLoad: {
    failed: 'Failed to load data. Please restart the app.',
    partial: 'Could not refresh: {{collections}}. Showing saved data — please restart the app.',
    collections: {
      products: 'products',
      productCategories: 'categories',
      stores: 'stores',
      users: 'staff',
      suppliers: 'suppliers',
      constants: 'settings',
      organization: 'organization',
    },
  },
  appName: 'ATLAS',
  save: 'Save',
  delete: 'Delete',
  deleting: 'Deleting...',
  isReturned: 'Return',
  search: 'Search',
  searching: 'Searching...',
  searchHint: 'Enter phone or name',
  clientSearchFailed: 'Search failed. Check your connection and try again',
  weight: 'Weight',
  price: 'Price',
  accumulate: 'Accumulate',
  reduct: 'Spend',
  phone: 'Phone',
  name: 'Name',
  create: 'Create',
  none: 'None',
  paymentMethods: 'Payment Methods',
  purchaseMethods: 'Purchase Methods',
  discountOptions: 'Available Discounts',
  configure: 'Configure',
  refresh: 'Refresh',
  language: 'Language',
  select: 'Select',
  pieceLong: 'Piece',
  piece: 'pcs',
  pcs: 'pcs',
  kgLong: 'Kilogram',
  kg: 'kg',
  grLong: 'Gram',
  gr: 'gr',
  lLong: 'Liter',
  l: 'l',
  mlLong: 'Milliliter',
  ml: 'ml',
  notFound: 'Not Found',
  updateApp: 'Update App',
  off: 'off',
  all: 'All',
  total: 'Total',
  filterByDate: 'Filter by Date',
  noItemsText: 'Nothing Found',
  notAllFieldsFilled: 'Not all fields are filled or filled incorrectly',
  minLengthError: 'Value must be at least {{minLength}} characters',
  maxLengthError: 'Value must be less than {{maxLength}} characters',
  minError: 'Value must be greater than {{min}}',
  maxError: 'Value must be less than {{max}}',
  ingredientNotFoundError: 'Ingredient {{name}} of product {{product}} not found in products. Please check the product composition.',
  patternError: 'Invalid {{type}} format',
  fieldIsRequiredError: 'This field is required',
  invalidNumberError: 'Input must be a number',
  emailTaken: 'Email is already taken',
  imageIsUploading: 'Image is uploading',
  add: 'Add',
  cancel: 'Cancel',
  confirm: 'Confirm',
  now: 'Now',
  date: 'Date',
  employee: 'Employee',
  continue: 'Continue',
  notSaved: 'Failed to Save',
  product: 'Product',
  store: 'Branch',
  organization: 'Organization',
  next: 'Next',
  openLink: 'Open Link',
  supplier: 'Supplier',
  suppliers: 'Suppliers',
  products: 'Products',
  productSearchPlaceholder: 'Search Products',
  billingAndPayment: 'Billing and Payment',
  resetData: 'Reset Data',
  misc: 'Miscellaneous',
  back: 'Back',
  success: 'Success',
  printFailed: 'Could not print. Check your printer.',
  done: 'Done',
  navigate: 'Navigate',
  role: 'Role',
  permissionDenied: 'Access denied. Please contact the administrator',
  other: 'Other',
  updateTimezone: 'Change Time Zone',
  networkErrorText: 'Device offline, unsaved data present. Please do not close the app/tab until internet connection is restored.',
  salesLimitUpgradeText: 'Your sales have reached the limits of your plan. Your account will be blocked soon. Please upgrade to a higher plan.',
  failedPaymentAlertText: 'Payment failed for your plan. Please check if there are sufficient funds on your card, a retry will be attempted soon.',
  blockedAlertText: 'Your account is blocked due to exceeding the sales limit. Please upgrade to a paid or higher plan.',
  paymentLapsedAlertText: 'Your subscription was not renewed because the payment did not go through. Please check your payment method or renew your plan in Billing and Payment.',
  upgrade: 'Upgrade',
  updatePaymentMethod: 'Update Payment Method',
  differentTimeZoneText: 'The time zone on your device is different from the branch\'s time zone. All dates will be displayed in the branch\'s time zone. Local branch time - {{time}}',
  cashFromCashbox: 'Cash from Cashbox',
  extractedCash: 'Extracted Cash',
  bankAccount: 'Bank Account',
  cash: 'Cash',
  paymentTerminal: 'Payment Terminal',
  find: 'Find',
  deleted: '[Deleted]',
  error: 'Error. If it persists please contact support',
  // ATL-2004: a guarded save whose outcome could not be established (global/Firebase/writeOutcome.ts).
  writeOutcomeUnknown: {
    sale: 'Could not confirm that the sale was saved. Check the sales list before ringing it up again.',
    record: 'Could not confirm that the operation was saved. Check the list of operations before saving it again.',
  },
  deleteWarningTitle: 'Confirm deletion',
  deleteWarningText: 'This action cannot be undone.',
  notANumberError: 'The values should be numbers, please check the corectness of the fields',
  amountMustBePositive: 'Amount should be a number more than 0',
  amountMustNotBeNegative: 'Amount cannot be negative',
  // ATL-1371 — `EditCartItemScreen` has always read these two, and neither locale defined them.
  // `t()` returns the KEY for a missing string and a key is truthy, so its `t('x') || 'fallback'`
  // never reached the fallback: the merchant was shown the literal word "quantityMustBePositive".
  quantityMustBePositive: 'Quantity should be more than 0',
  priceMustBeNonNegative: 'Price cannot be negative',
  quantityTooLargeError: 'Quantity is too large. Enter a value up to {{max}}.',
  lastServerUpdate: 'Last server update',
  lastLocalUpdate: 'Last local update',
  searchResults: 'Search results',
  csvExport: 'Export to CSV',
  excelExport: 'Export to Excel',
  importFileMalformedQuotes: 'row {{row}} opens a quote in a cell and never closes it, so the file was not read — the rows below it would have been lost. Save the file as .xlsx and upload it again',
  sheetsExport: 'Export to Google Sheets',
  batchEditProducts: 'Batch edit products',
  viewModeSwitch: 'View mode:',
  sales: 'Sales',
  moreSettings: 'More settings',
  bonusValueChange: {
    addition: 'Bonus addition',
    subtraction: 'Bonus subtraction',
    newBonusValue: 'New bonus value'
  },
  platformDependantSelect: {
    chooseOther: 'Choose an item from the list'
  },
  cartView: {
    discount: 'Discount',
    totalWithoutDiscount: 'Total without discount',
    bonusReduction: 'Bonus deduction',
    punchCardReduction: 'Free product',
    total: 'Total',
    bonusAccumulation: 'Bonus accumulation',
    totalPurchasePrice: 'Total purchase price',
  },
  changeView: {
    change: 'Change',
    otherValue: 'Other amount',
  },
  clientView: {
    newClient: 'New client',
    b2cClient: 'Individual',
    b2bClient: 'Organization',
    errorForPhoneNumberFormat: 'Phone number must start with +',
    errorForPhoneNumberLength: 'Phone number must be more than 9 digits',
  },
  support: {
    support: 'Support',
    welcome: 'Hi! 👋 This is Atlas support. Describe your question and we usually reply within 1-2 minutes.',
    newMessage: 'New message from support',
    newMessageFrom: 'New message from {{name}}',
    newMessageAttachment: 'Sent an attachment',
    back: 'Back',
    placeholder: 'Message',
    emptyTitle: 'How can we help?',
    replyTime: 'We usually reply within 1-2 minutes',
    awaitingReply: "We'll reply within 1-2 minutes 🙌",
    fileTooLarge: 'File too large (max 25 MB)',
    sendErrorEmpty: 'The message is empty. Type some text or attach a file.',
    sendErrorFileTooLarge: 'The file is too large, the limit is 25 MB. Remove it or attach a smaller file.',
    sendErrorFileType: 'This file type cannot be sent. You can attach a photo or a PDF.',
    sendErrorFileUnreadable: 'The attachment could not be read. Remove it and attach the file again.',
    sendErrorNetwork: 'No connection to the server. Check your internet and send again, your message is still in the input field.',
    sendErrorServer: 'The server is not responding right now. Send again in a minute, your message is still in the input field.',
    sendErrorGeneric: 'The message was not sent. Send it again, it is still in the input field.',
    loadError: 'Could not load the support chat. Close it and open it again.',
    loadErrorNetwork: 'No connection to the server. Check your internet and open the chat again.',
    a11yAttachImage: 'Attach image',
    a11yAttachFile: 'Attach file',
    a11ySend: 'Send',
    draftTitle: 'Suggested products',
    draftHint: 'Open each product, check the details, enter the cost price and save.',
    draftOpen: 'Open and save',
    draftDismiss: 'No, thanks',
    draftSaved: 'Saved',
    draftSalePrice: 'Suggested price: {{price}}',
    draftSalePricePerUnit: 'Suggested price: {{price}} per {{unit}}',
    draftNoPrice: 'You will enter the sale price',
    draftAlreadyInCatalogue: 'A product with this name is already in your catalogue',
    draftAllSaved: 'All products saved',
    draftDismissed: 'You declined these products',
    draftExpired: 'This suggestion has expired',
    draftLoadError: 'Could not load the suggestion',
    draftRetry: 'Retry',
    draftActionError: 'Something went wrong. Please try again.',
    draftOpenInApp: 'You can save products in the Products section once access to the app is restored.',
    draftBanner: 'Draft from support. Check the details, enter the cost price and the other required fields, then tap Save.',
    quickReplyAddProduct: 'Add a product',
    quickReplyNewSale: 'New sale',
  },
  helpCenter: {
    helpCenter: 'Help Center',
    greeting: 'Hello!',
    howCanWeHelp: 'How can we help?',
    chat: 'Chat',
    help: 'Help',
    moreOptions: 'More options',
    recentUpdates: 'Recent updates',
    checkLatestNews: 'Check out our latest news',
    askQuestion: 'Ask a question',
    ourBotAndTeam: 'Our bot and team can help',
    startConversation: 'Start conversation',
    recentConversations: 'Recent conversations',
    newMessagesAvailable: 'You have {{count}} new message{{count, plural, one {} other {s}}}',
    viewPastConversations: 'View your past conversations',
    openChatForMessages: 'Open chat to see messages',
    loadingChat: 'Loading chat...',
    chatWithSupport: 'Chat with Support',
    webChatInstructions: 'Click the button below to open the chat window in a new overlay.',
    mobileChatInstructions: 'Tap the button below to start chatting with our support team.',
    openChat: 'Open Chat',
    chatUnavailable: 'Chat Unavailable',
    chatConfigurationMissing: 'Chat service is not properly configured. Please contact support.',
    goBack: 'Go Back',
    whatIsNew: 'News and updates',
    contactSupport: 'Contact support via form',
    pricing: 'Pricing',
    gettingStarted: 'Getting started',
    welcomeMessage: 'Welcome, {{name}}! Let\'s figure out how to use ATLAS and how to start managing your business in it 💫',
    done: 'Done',
    skip: 'Skip',
    ourInstagram: 'ATLAS on Instagram',
    writeToWhatsapp: 'Contact support via WhatsApp',
    AtlasAppStore: 'ATLAS on the App Store',
    AtlasGooglePlay: 'ATLAS on Google Play',
    AtlasWeb: 'ATLAS web version for computers',
    termsOfUse: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    eula: 'End User License Agreement',
    instructionsForretail: 'Instructions for retail',
    instructionsForonline: 'Instructions for online sales',
    instructionsForrestaurant: 'Instructions for cafes, restaurants, and takeaway points',
    instructionsFormanufacture: 'Instructions for manufacturing and workshops',
    instructionsForsuppliers: 'Instructions for distributors and suppliers',
    instructionsForservices: 'Instructions for service businesses',
    instructionsForother: 'Instructions',
    instructionsForundefined: 'Instructions',
  },
  ingredientsView: {
    composition: 'Composition',
    costOfOnePiece: 'Cost of one piece',
    costTotal: 'Total cost',
    totalQuantity: 'Total quantity',
    quantity: 'Quantity',
    price: 'Price',
    totalPrice: 'Total price',
    addIngredientsHint: 'Add ingredients by clicking on the plus sign above',
  },
  newSale: {
    newSale: 'New sale',
    saleSaved: 'Sale saved',
    receiptNotFiscalized: 'Sale saved, but the receipt was not fiscalized',
    receiptNotFiscalizedWithReason: 'Sale saved, but the receipt was not fiscalized: {{reason}}',
    openSalesHistory: 'Open sales history',
    tapToOpenSalesHistory: 'Tap to open sales history',
    unfiscalizedSalesInSession: 'Receipts without a fiscal mark: {{count}}. The sales are saved.',
    fiscalOperatorNotConfigured: 'no fiscal operator configured',
    fiscalLoginFailed: 'could not sign in to the OFD',
    fiscalOperatorUnsupported: 'this fiscal operator is not supported by the app',
    receiptPrintBlocked: 'The receipt could not be printed — allow pop-ups for this site.',
    priceType: 'Price Type',
    selectPriceType: 'Select Price Type',
    defaultPrice: 'Default Price',
    retail: 'Retail',
    priceTypeAutoChanged: 'Price type changed to {{name}}',
    interfaceSettingsTitle: 'New Sale Settings',
    checkoutStyle2Steps: 'Two-step checkout',
    internalReceiptWidth: 'Internal receipt width',
    internalReceiptFontSize: 'Internal receipt font size',
    showDateField: 'Show Sale Date field',
    showStoreField: 'Show Branch field',
    showCommentField: 'Show Sale Comment field',
    showTableNumberField: 'Show Table Number field',
    mergeSimilarItemsIntoOneRow: 'Merge identical items into one row',
    mergeSimilarItemsIntoOneRowTrue: 'Yes, when adding a product to the cart, the quantity of the existing product will increase',
    mergeSimilarItemsIntoOneRowFalse: 'No, when adding a product to the cart, a new row will be created',
    multipleProductSelection: 'Multiple product selection when adding items to cart on mobile screens',
    interfaceSettings: 'Interface Settings',
    savedCarts: 'Open receipts',
    addCartItem: 'Add product',
    addCartItemEmptyHint: 'No products here yet. Add your first one and it will show up in this list right away.',
    addCartItemSampleOnlyHint: 'For now there is only the sample test product. Add your own products to start selling them.',
    addCartItemAskAdmin: 'Ask your admin to add products.',
    addCartItemCreateProduct: 'Create product',
    addCartItemNewProduct: 'New product',
    addSelectedToCart: 'Add to sale',
    editCartItem: 'Edit product',
    shiftNotOpenedError: 'No rights to sell without a shift. Please open a shift first. You can postpone the current sale to process it later.',
    gridLeftWidth: 'Left column width (10 = half of the screen)',
    withoutDiscount: 'Without discount',
    name: 'Name',
    quantity: 'Quantity/Weight',
    purchasePrice: 'Purchase price',
    salePrice: 'Sale price',
    individualProductDiscount: 'Product discount',
    deleteFromCart: 'Remove from cart',
    firstPaymentValue: 'First amount',
    firstPaymentMethodAndValue: 'First payment method and amount',
    secondPaymentMethodAndValue: 'Second payment method and amount',
    secondSum: 'Second amount',
    printCheck: 'Print receipt',
    mixedPayment: 'Mixed payment',
    postPayment: 'Post-payment',
    saveCartForLater: 'Postpone',
    receipt: 'Receipt',
    commonError: 'Either there are no products in the cart, or no payment method has been selected',
    cartItemsCannotBeEmpty: 'Cart cannot be empty',
    addProductToCheckout: 'Add a product to complete the sale',
    priceMissingError: 'A product has no price for this store. Refresh the catalog or set its price.',
    mixedPaymentFirstPaymentNotNumber: 'First payment method amount for mixed payment is not a number',
    delvieryPriceNotANumberError: 'Delivery price is not a number',
    choosePurchaseMethodError: 'Please choose a purchase method for this sale',
    choosePaymentMethodError: 'Please choose a payment method for this sale',
    noPaymentMethodsForStore: 'No payment methods available. Go to Settings → Payment Methods to enable for this branch.',
    noPurchaseMethodsForStore: 'No purchase methods available. Go to Settings → Purchase Methods to enable for this branch.',
    mixedPaymentSecondPaymentMethodEmpty: 'Please choose a second payment method for mixed payment',
    mixedPaymentFirstPaymentAmountEmpty: 'Fill in first payment method amount for mixed payment',
    mixedPaymentSecondPaymentIsSameAsFirst: 'Please choose a different second payment method for mixed payment',
    deliveryPaymentSourceEmptyError: 'Please choose delivery payment source',
    deliveryAddressEmptyError: 'Enter a delivery address or choose a client with an address',
    addProduct: 'Add product',
    saleDate: 'Sale date',
    tableNumber: 'Table number',
    comment: 'Comment',
    client: 'Client',
    proceedToPayment: 'To payment',
    customProduct: 'Custom product',
    delivery: 'Delivery',
    deliveryPrice: 'Delivery Price',
    deliveryPaidByCustomer: 'Delivery is paid by Customer',
    deliveryPaidBySeller: 'Delivery is paid by Seller',
    deliveryAddress: 'Delivery address',
    deliveryIncludeInReceipt: 'Show delivery info in Cart',
    appearance: 'User Interface Settings',
    internalReceipt: 'Receipt Settings',
    deliveryDefaultSettings: 'Default Delivery Settings',
    defaultDeliveryPaidBy: 'Delivery paid by default',
    defaultDeliverySpendingCategory: 'Default spending category for delivery',
    additionalFields: 'Additional Fields',
    other: 'Other',
    showSaveCartForLater: 'Show Save Cart for Later button',
    deliveryPaymentSourceWallet: 'Payment source',
    showPurchasePriceInEditCartItem: 'Show purchase price in Edit Cart Item Screen',
    showTotalPurchasePriceInCart: 'Show total purchase price in cart',
    cannotSellOutOfStock: 'Not enough {{productName}} in stock',
    cannotSellOutOfStockIngredients: 'Not enough of the ingredient {{ingredientName}} for {{productName}}',
    stockShortageTitle: 'Not enough stock',
    stockShortageIngredientOf: 'ingredient of {{productName}}',
    stockShortageAvailable: 'In stock: {{quantity}}',
    stockShortageAttempted: 'You are trying to sell: {{quantity}}',
    stockShortageReceiveHint: 'If the goods have arrived, record an acceptance — you can change the quantity before saving. Your cart will be kept.',
    stockShortageReceive: 'Record acceptance',
    stockShortageAskAdmin: 'To sell more than is in stock, an acceptance has to be recorded. Ask an administrator.',
    stockShortageBackToCart: 'Back to cart',
    discountAmount: 'Amount discount...',
    discountAmountPopupTitle: 'Discount Amount'
  },
  salesHistory: {
    salesHistory: 'Sales history',
    saleDetail: 'Sale',
    returnSale: 'Return sale',
    salesStats: 'Sales report',
    returnPresent: 'Return present',
    priceType: 'Price Type',
    replaceProduct: 'Replace product',
    returnMoney: 'Refund',
    chooseReturnItems: 'Please select items for return',
    totalReturnedAmount: 'Total to return {{returnedQuantity}} items for the amount of {{amount}}',
    returnItem: 'Return',
    returnQuantity: 'Return quantity',
    returnItemAmount: 'Return amount',
    returnQuantityExceedsSold: 'Cannot return more than was sold — {{name}}: {{sold}} sold',
    cumulativeRefundExceedsSale: 'This sale has already been refunded {{alreadyReturned}} of {{refundable}}. A further refund of {{requested}} would exceed the sale total. Delete the earlier return first if it was a mistake.',
    returnType: 'Return method',
    moneyReturnType: 'Money return method',
    updateStockText: 'Add the product back to stock or write off?',
    takeBack: 'Add back',
    writeOff: 'Write off',
    returnReason: 'Return reason',
    returnReasons: 'Return reasons',
    comment: 'Comment',
    return: 'Make a return',
    deleteSale: 'Delete the sale completely',
    cashbox: 'Cash register',
    cashier: 'Cashier',
    client: 'Client',
    discount: 'discount',
    totalWithoutDiscount: 'Total without discount',
    totalDiscount: 'Total discount',
    bonusReduction: 'Payment with bonuses',
    total: 'TOTAL',
    payment: 'Payment',
    thankYouForYourPurchase: 'Thank you for your purchase!',
    returnFiled: 'Return filed',
    date: 'Date - ',
    reason: 'Reason - ',
    returnAmount: 'Refund amount - ',
    returnUpdateStockText: 'Returned products',
    inputPhoneNumber: 'Please enter the phone number',
    send: 'Send',
    sendToWhatsapp: 'Send receipt to Whatsapp',
    printReceipt: 'Print fiscal receipt',
    sendToSms: 'Send receipt via SMS',
    noSms: 'No SMS',
    copyReceipt: 'Copy receipt',
    notFiscalized: 'The receipt lacks a fiscal mark',
    ofdError: 'Something with OFD',
    ofdErrorWithReason: 'OFD error - {{reason}}',
    retryOfd: 'Retry sending the receipt to OFD',
    alreadyFiscalized: 'This receipt is already registered with the OFD — not sending it again',
    fiscalStateUnverifiable: 'Could not check whether the receipt is registered. Check the connection and retry — nothing was sent',
    receiptContentUnavailable: 'The receipt is registered but its text was not saved — open it in the OFD cabinet',
    printInternalReceipt: 'Print receipt',
    printReturnReceipt: 'Print return receipt',
    printInvoice: 'Print invoice',
    printOptions: 'Print',
    printInternalReceiptOption: 'Internal receipt',
    printInvoiceOption: 'Invoice',
    printTemplatesOption: 'Print templates',
    salePayment: 'Sale payment',
    paid: 'Paid',
    notPaid: 'Not paid',
    paymentDate: 'Payment date',
    fileReturn: 'File a return',
    deleteReturn: 'Delete return',
    periodContainsNotFiscalizedSales: 'This period contains sales without a fiscal mark.',
    batchFiscalizationRetry: 'Retry sending non-fiscal sales to OFD',
    deliveryPaidByCustomer: 'Delivery was paid by Customer',
    deliveryPaidBySeller: 'Delivery was paid by Seller',
    delivery: 'Delivery',
    deliveryAddress: 'Delivery address',
    deliveryPrice: 'Delivery price',
    clientAddress: 'Client address',
  },
  productStocks: {
    productStocks: 'Product stocks',
    productStockMovementHistory: 'Stock history',
    newProduct: 'New product',
    openingBalance: 'Opening balance',
    stockReset: 'Stock reset',
    sale: 'Sale',
    writeOff: 'Write-off',
    revision: 'Revision',
    return: 'Return',
    supply: 'Supply',
    manufacture: 'Manufacture',
    transfer: 'Transfer',
    deleteTransfer: 'Delete transfer',
    deleteSupply: 'Delete supply',
    deleteManufacture: 'Delete manufacture',
    deleteSale: 'Delete sale',
    deleteReturn: 'Delete return',
    deleteWriteOff: 'Delete write-off',
    deleteRevision: 'Delete revision',
    complexSale: 'Complex sale',
    deleteComplexSale: 'Delete complex sale',
    editComplexSale: 'Edit complex sale',
    manualChange: 'Manual Change',
    type: 'Type',
    increment: 'Increment',
    previousInStock: 'Previous in stock',
    possibleStockError: 'Possible error, recalculation might be needed for previous operation',
    instructions: 'Instructions',
    changeStock: 'Change stock',
    createSupply: 'Create supply',
    createWriteOff: 'Create write-off',
    createRevision: 'Create revision',
    productInfo: 'Product information',
    showInImportantSection: 'Show in important products',
    stockThreshold: 'Low stock quantity alert',
    startingStock: 'Starting quantity for the period',
    newProductCount: 'Quantity for new product',
    saleCount: 'Sales',
    deleteSaleCount: 'Deleted sales',
    complexSaleCount: 'Complex sales',
    editComplexSaleCount: 'Edited complex sales',
    deleteComplexSaleCount: 'Deleted complex sales',
    writeOffCount: 'Write-offs',
    deleteWriteOffCount: 'Deleted write-offs',
    supplyCount: 'Supplies',
    deleteSupplyCount: 'Deleted supplies',
    manufactureCount: 'Manufactures',
    deleteManufactureCount: 'Deleted manufactures',
    transferCount: 'Transfers',
    returnCount: 'Returns',
    deleteReturnCount: 'Deleted returns',
    totalMovement: 'Total movement',
    endingStockShouldBe: 'Ending stock (should be)',
    revisionCount: 'Revisions',
    deleteRevisionCount: 'Deleted revisions',
    manualChangeCount: 'Manual Change',
    endingStockWithRevisions: 'Ending stock with revisions',
    currentStock: 'Current stock in the system',
    noMovement: 'No stock changes for this period',
    editMovement: 'Edit Movement',
    foundError: 'Found an error in the report?',
    foundErrorDescription: 'This could be due to an unstable internet connection. Type the new product stock to update',
    recalculate: 'Recalculate',
    productStocksInstructions: 'Stock instructions',
    importantProducts: 'Important products',
    inStock: 'In stock',
    weeklySales: '7d sales',
    weeklyWriteOffs: '7d write-offs',
    newStockValue: 'New Stock Value',
    successManualUpdate: 'Success. Please go back and reload this page to reflect the changes.',
    savedPastDate: 'Saved with past date',
    savedToServerLater: 'Saved to server later due to connection issues',
    purchaseSum: 'Stock amount (purchase price)',
    saleSum: 'Stock amount (sale price)',
    isService: 'Service',
    activeOrders: 'Active orders',
  }, 
  revisions: {
    revisions: 'Revisions',
    revision: 'Revision',
    revisionStats: 'Revision report',
    missing: 'Deficit',
    surplus: 'Surplus',
    balance: 'Balance',
    listMissing: 'List of deficits',
    listSurplus: 'List of surpluses',
    otherProductMixUp: 'Mixed up with another product',
    forgotToCreateSupply: 'Forgot to create supply',
    supplyError: 'Incorrect supply created',
    forgotToWriteOff: 'Forgot to write off',
    forgotToMarkASale: 'Did not mark as a sale',
    wrongCount: 'Counted incorrectly',
    other: 'Unknown',
    total: 'Total',
    totalWithCorrections: 'Total with corrections',
    category: 'Category',
    name: 'Name',
    quantity: 'Quantity',
    quantityFact: 'Actual quantity',
    amount: 'Amount',
    reason: 'Reason',
    correctedAmount: 'Corrected amount',
    deletedProductsError: 'The stock count was not saved: these products were deleted and cannot be counted — {{products}}. Set their actual quantity equal to the quantity shown and save again. Your counts stay on this screen.',
  },
  writeOffs: {
    ingredientQuantityTooLargeError: 'The quantity of ingredient {{name}} that this write-off produces is too large. The quantity written off for one product must be up to {{max}}.',
    writeOffs: 'Write-offs',
    writeOff: 'Write-off',
    writeOffStats: 'Write-off report',
    quantity: 'Quantity',
    reason: 'Reason',
    amount: 'Amount',
    writeOffReasons: 'Reasons for write-offs',
  },
  supplies: {
    supplies: 'Supplies',
    supply: 'Supply',
    deletedSupplier: 'Deleted supplier',
    paid: 'Paid',
    notPaid: 'Not paid',
    totalSuppliesSum: 'Total supply amount for the period',
    choosePaymentMethod: 'Choose payment method',
    instructions: 'Filling instructions',
    supplyDate: 'Supply date',
    supplyReturnIsPresent: 'Are there any returns?',
    returnPresentTrue: 'Return present',
    returnPresentFalse: 'No return',
    supplyPricesHaveUpdated: 'Have prices changed?',
    pricesUpdatedTrue: 'Prices changed',
    pricesUpdatedFalse: 'Prices unchanged',
    supplyItems: 'Items',
    fillInBarcode: 'Enter barcode',
    returnMode: 'Return mode',
    supplyMode: 'Supply mode',
    name: 'Name',
    purchasePrice: 'Purchase price',
    supplyQuantity: 'Supply quantity',
    returnQuantity: 'Return quantity',
    sellPrice: 'Selling price',
    totalPrice: 'Total',
    supplyTotal: 'Total supply',
    returnTotal: 'Total return',
    total: 'Total',
    invoiceScans: 'Invoice photos',
    takePhoto: 'Take photo',
    choosePhoto: 'Choose from gallery',
    invoicePayment: 'Invoice payment',
    paymentDate: 'Payment date',
    createPaymentTransaction: 'Create payment transaction automatically',
    stickers: 'Stickers',
    payments: 'Payments',
    saveErrorName: 'Enter name',
    deleteSupplier: 'Delete supplier',
    fieldNotANumberError: '{{productName}}: {{fieldName}} must be a valid number',
    fieldTooLargeError: '{{productName}}: {{fieldName}} is too large. Enter a value up to {{max}}.',
    totalFieldTooLargeError: '{{productName}}: the total {{fieldName}} across all lines of this supply is too large. The total for one product must be up to {{max}}.',
    instructionsLink: 'https://www.notion.so/atlas-app/What-are-Supplies-and-how-to-create-them-9956e87ae47b404c85a995d8f4f09456?pvs=4#f549836bfa6a4859bb7cb8ab43209009'
  },
  // ATL-1440: Settings → API tokens (Atlas API v1 for AI agents and integrations).
  apiTokens: {
    title: 'API tokens',
    intro: 'An API token connects an AI agent (Claude, ChatGPT, Plank) or another program to Atlas. It acts as the admin who created it, in this organization only. Everything done with a token is recorded in the log below.',
    notAvailable: 'The API is not available for this organization yet: it opens to organizations whose data has moved to the new database.',
    undetermined: 'Could not check whether the API is available for this organization. Try again later.',
    create: 'Create token',
    name: 'Name',
    namePlaceholder: 'E.g. Claude — reports',
    scopes: 'Permissions',
    scope_read: 'Read everything (products, stock, sales, acceptances, reports)',
    scope_read_products: 'Read: products and prices',
    scope_read_stock: 'Read: stock by warehouse',
    scope_read_sales: 'Read: sales and revenue',
    scope_write_sales: 'Create sales',
    scope_write_products: 'Create and edit products',
    scope_write_danger: 'Dangerous actions (deletion)',
    scope_draft_sales: 'Sale drafts (you complete them yourself)',
    scope_draft_acceptances: 'Acceptance drafts (you complete them yourself)',
    scopeSoon: 'coming soon',
    expiresIn: 'Expires in',
    days: '{{count}} days',
    issue: 'Create',
    cancel: 'Cancel',
    secretTitle: 'Token created',
    secretWarning: 'Copy the token now. Atlas keeps only its fingerprint and will not show it again.',
    copy: 'Copy',
    copied: 'Copied',
    done: 'Done',
    noTokens: 'No tokens yet.',
    status_active: 'Active',
    status_expired: 'Expired',
    status_revoked: 'Revoked',
    expires: 'Valid until {{date}}',
    lastUsed: 'Last used {{date}}',
    neverUsed: 'Not used yet',
    createdBy: 'Created by {{name}}',
    revoke: 'Revoke',
    revokeTitle: 'Revoke token?',
    revokeText: 'Token "{{name}}" stops working immediately. This cannot be undone: access will need a new token.',
    auditTitle: 'Activity log',
    auditEmpty: 'Nothing recorded yet.',
    loadMore: 'Show more',
    actorAgent: 'Agent "{{name}}"',
    actorUser: '{{name}}',
    outcome_success: 'ok',
    outcome_denied: 'refused',
    outcome_error: 'error',
    action_api_token_create: 'created a token',
    action_api_token_revoke: 'revoked a token',
    action_whoami: 'checked the connection',
    action_stores_list: 'listed stores',
    action_products_list: 'read products',
    action_sales_list: 'read sales',
    action_acceptances_list: 'read acceptances',
    action_reports_revenue_by_day: 'read revenue by day',
    action_reports_top_products: 'read top products',
    action_reports_stock_balances: 'read stock balances',
    action_reports_stock_balance: 'read a product’s stock',
    action_reports_sales_summary: 'read the sales summary',
    action_products_get: 'read a product',
    action_sales_get: 'read a sale',
    action_mcp_initialize: 'connected over MCP',
    action_mcp_tools_list: 'listed the MCP tools',
    action_mcp_tools_call: 'called an unknown MCP tool',
    action_mcp_batch: 'called MCP',
    action_mcp_request: 'called MCP',
    action_mcp_list_products: 'MCP: read products',
    action_mcp_get_product: 'MCP: read a product',
    action_mcp_list_stocks: 'MCP: read stock balances',
    action_mcp_get_stock: 'MCP: read a product’s stock',
    action_mcp_list_sales: 'MCP: read sales',
    action_mcp_get_sale: 'MCP: read a sale',
    action_mcp_sales_summary: 'MCP: read the sales summary',
    action_sales_draft_create: 'proposed a sale',
    action_acceptances_draft_create: 'proposed an acceptance',
    action_api_draft_create: 'proposed a draft',
    action_api_draft_apply: 'completed an agent draft',
    action_api_draft_dismiss: 'dismissed an agent draft',
    action_drafts_list: 'listed the organization’s drafts',
    action_drafts_get: 'checked a draft',
    action_api_token_oauth_approve: 'approved an AI assistant connection',
    action_api_token_oauth_deny: 'denied an AI assistant connection',
    action_api_token_oauth_code_reuse: 'reused a connection code — the connection was revoked',
    action_api_token_oauth_refresh_reuse: 'reused an old key — the connection was revoked',
    action_mcp_get_account: 'MCP: checked the connection',
    action_mcp_list_stores: 'MCP: read the store list',
    action_mcp_list_acceptances: 'MCP: read acceptances',
    action_mcp_revenue_by_day: 'MCP: read revenue by day',
    action_mcp_top_products: 'MCP: read top products',
    action_mcp_list_drafts: 'MCP: listed the organization’s drafts',
    action_mcp_get_draft: 'MCP: checked a draft',
    action_mcp_preview_sale_draft: 'MCP: showed a sale draft for confirmation',
    action_mcp_create_sale_draft: 'MCP: proposed a sale',
    action_mcp_preview_acceptance_draft: 'MCP: showed an acceptance draft for confirmation',
    action_mcp_create_acceptance_draft: 'MCP: proposed an acceptance',
    error_too_many_active_tokens: 'This organization already has the maximum number of active tokens. Revoke one first.',
    error_generic: 'That did not work. Please try again.',
    nameRequired: 'Enter a name',
  },
  apiDrafts: {
    title: 'AI agent drafts',
    intro: 'Sales and acceptances an AI agent prepared with an API token. The agent saves nothing itself: open a draft, check it and save it as usual — or dismiss it.',
    empty: 'No open drafts.',
    agent: 'AI agent',
    kind_sale: 'Sale',
    kind_acceptance: 'Acceptance',
    proposedBy: '{{name}} (token issued by {{person}}) · {{date}}',
    expires: 'Valid until {{date}}',
    purchasePrice: 'cost {{price}}',
    openSale: 'Open in New Sale',
    openAcceptance: 'Open acceptance',
    dismiss: 'Dismiss',
    cancel: 'Cancel',
    dismissTitle: 'Dismiss this draft?',
    dismissText: 'Nothing will be saved. The agent will see the draft as dismissed.',
    otherStore: 'This draft is for another store. Open it while working in that store.',
    storeMissing: 'The draft’s store no longer exists.',
    supplierMismatch: 'An acceptance is recorded against one supplier, and these products do not share one. The draft can only be dismissed.',
    productsMissing: 'These products are no longer in the catalogue: {{names}}. The draft can only be dismissed.',
    savedConfirming: 'Saved on this device, confirming…',
    savedRefused: 'The record was saved but not linked to the draft: {{reason}} Do not complete the draft again — dismiss it.',
    saleBanner: 'Cart from a draft by {{name}}. Check it and check out as usual.',
    acceptanceBanner: 'Acceptance from a draft by {{name}}. Check it and save as usual.',
    linkRefused: 'Saved, but not linked to the agent’s draft: {{reason}}',
    refusal_predates_proposal: 'the record was created before the draft.',
    refusal_in_other_organization: 'the record belongs to another organization.',
    refusal_not_found: 'the record was not found.',
    refusal_store_mismatch: 'the record was saved in another store.',
    refusal_no_draft_products: 'the record has none of the draft’s products.',
    refusal_record_already_claimed: 'this record is already linked to another draft.',
    refusal_permission_denied: 'your role cannot act on this draft.',
    refusal_invalid_firestore_id: 'the record id is invalid.',
    refusal_other: 'the server refused to link it.',
    error_already_decided: 'The draft was already completed or dismissed.',
    error_permission_denied: 'Your role cannot act on this draft.',
    error_generic: 'Something went wrong. Please try again.',
  },
  // ATL-1694: connecting Claude / ChatGPT to Atlas over MCP — the consent screen and the help screen.
  aiAssistants: {
    title: 'AI assistants: Claude and ChatGPT',
    whatTitle: 'What this is',
    whatText: 'You can connect Atlas to Claude or ChatGPT. Then you simply ask the assistant about your business and it looks the answer up in Atlas itself.',
    canReadTitle: 'What the assistant can look at',
    canRead: 'Stores, products and prices, stock by warehouse, sales, revenue by day, best-selling products, acceptances and the organization’s drafts.',
    canWriteTitle: 'What the assistant can write',
    canWrite: 'Only drafts of sales and acceptances. The assistant never sells anything itself and never changes stock or money. A draft waits for you in Settings → AI agent drafts: you open it, check it and save it yourself — or dismiss it.',
    needTitle: 'What you need',
    need_admin: 'You are an admin of the organization in Atlas. Only an admin can approve a connection.',
    need_org: 'Connections are enabled for your organization. See the status below.',
    need_claude: 'For Claude: an account on claude.ai. The free plan allows one custom connector. On Team and Enterprise plans the workspace Owner adds the connector first.',
    need_chatgpt: 'For ChatGPT: a plan that lets you add your own MCP servers (usually Plus, Pro, Business or Enterprise). On Business and Enterprise this may be limited to workspace admins.',
    statusTitle: 'Your organization\'s status',
    status_available: 'Ready to connect.',
    status_notAdmin: 'Only an admin of the organization can connect an assistant. Ask an admin, or sign in as one.',
    statusLoadError: 'Could not load the status. Check your connection and try again.',
    unavailable_organization_not_on_supabase: 'AI assistants can only be connected by organizations already moved to the new Atlas database. Yours has not been moved yet.',
    unavailable_not_enabled: 'AI assistant connections are not enabled for your organization yet.',
    unavailable_undetermined: 'Could not check whether connecting is available. Try again in a few minutes.',
    serverTitle: 'Server address',
    serverText: 'Paste this address into Claude or ChatGPT. Copy it in full.',
    copy: 'Copy',
    copied: 'Copied',
    claudeTitle: 'Connect Claude',
    claudeStep1: 'Open claude.ai (or the Claude app) and sign in.',
    claudeStep2: 'Open Customize → Connectors.',
    claudeStep3: 'Click Add custom connector.',
    claudeStep4: 'Name: Atlas. URL: paste the server address. Leave OAuth Client ID and Client Secret empty. If Claude asks which OAuth client to use, choose Use Claude\'s published identity or Register automatically.',
    claudeStep5: 'Click Add, then Connect.',
    claudeStep6: 'An Atlas page opens. Sign in if asked. Check that the request comes from Claude (claude.ai), tick the permissions you want and press Allow.',
    claudeStep7: 'You are back in Claude and Atlas is connected. In a chat, turn it on or off from «+» → Connectors.',
    claudeTeam: 'Team and Enterprise: the Owner first adds the connector in Organization settings → Connectors → Add → Custom → Web with this address. Then each member connects themselves: Customize → Connectors → Atlas → Connect.',
    claudeCodeTitle: 'Claude Code (for developers)',
    claudeCodeText: 'Run the command below in a terminal. Then type /mcp in Claude Code, choose atlas and sign in — the same Atlas page opens.',
    chatgptTitle: 'Connect ChatGPT',
    chatgptStep1: 'Open chatgpt.com and sign in.',
    chatgptStep2: 'Open Plugins (or Apps) and click «+» → Add custom MCP server. If you do not see it: Settings → Apps & Connectors → Advanced settings → turn on Developer mode, go back to Apps & Connectors and click Create.',
    chatgptStep3: 'Name: Atlas. URL: paste the server address. Authentication: OAuth.',
    chatgptStep4: 'Confirm that you understand the warning about custom servers and click Create (or Connect).',
    chatgptStep5: 'An Atlas page opens. Check that the request comes from ChatGPT (chatgpt.com), tick the permissions you want and press Allow.',
    chatgptStep6: 'In a new chat, turn Atlas on from «+» (or the tools menu) and ask your question.',
    chatgptNote: 'ChatGPT renames its menus from time to time. If you cannot find the item, look for «MCP», «Connectors» or «Developer mode» in settings.',
    checkTitle: 'Check that it works',
    checkText: 'Ask the assistant: «What can you see in Atlas?» It lists what it has access to, which depends on the permissions you ticked. If «See all data» is ticked, ask: «Show my stores in Atlas» — it should list your stores. Settings → API tokens will also show the Claude or ChatGPT connection with the time it was last used.',
    examplesTitle: 'Example requests',
    examplesText: 'Copy one and paste it into the chat:',
    example_revenue: 'What was yesterday\'s revenue across all stores?',
    example_topProducts: 'Which 10 products sold best last week?',
    example_stock: 'How much milk is left in the «Central» warehouse?',
    example_salesToday: 'How many sales were there today, and for how much?',
    example_acceptanceDraft: 'Prepare an acceptance draft for the «Central» warehouse: milk 1 l — 20 pcs at 400 each.',
    writeTitle: 'How the assistant writes',
    writeStep1: 'You ask it to prepare a sale or an acceptance.',
    writeStep2: 'The assistant first shows exactly what it will record — store, products and quantities (for an acceptance, purchase prices too; sale prices come from the price list at checkout) — and asks whether it is right.',
    writeStep3: 'Only after your «yes» does it create a draft. Claude and ChatGPT may also ask your permission for this action — approve it.',
    writeStep4: 'Open Settings → AI agent drafts, check the draft and save it like an ordinary sale or acceptance — or dismiss it.',
    writeNote: 'A draft is kept for 7 days. Until you save it, nothing is sold and stock and money are unchanged.',
    writeScopesNote: 'For the assistant to prepare drafts, tick «See all data» as well as «Propose drafts» when you connect: otherwise it cannot see your stores and products. The assistant does not set the supplier of an acceptance draft — it follows the products, as in an ordinary acceptance.',
    troubleTitle: 'If something does not work',
    trouble_admin: 'Atlas says only an admin of the organization can connect an assistant — sign in to Atlas as an admin, or ask one to connect the assistant.',
    trouble_org: 'Atlas says connecting is only available to organizations moved to the new database, or that it is not enabled for your organization yet — see the status above. Until the organization is moved, an assistant cannot be connected; if it is not enabled, write to support.',
    trouble_url: 'The assistant says it cannot reach the server (for example «Couldn\'t reach the MCP server») — check that the address is pasted exactly, with no spaces or extra characters.',
    trouble_reconnect: 'The assistant no longer sees Atlas or asks you to sign in again — access was revoked or expired, or the person who approved it is no longer an admin. Connect again.',
    trouble_scopes: 'The assistant cannot see some data or cannot create a draft — that permission was not ticked when connecting. Revoke the connection and connect again with the permissions you need.',
    trouble_rate: 'The assistant says there are too many requests (for example "rate limited" or 429) — one connection can make up to 60 requests a minute, and all of the organization\'s connections and tokens together up to 120. Wait a minute and try again.',
    trouble_support: 'Still stuck — write to support from the app.',
    disconnectTitle: 'How to disconnect',
    disconnect_atlas: 'In Atlas: Settings → API tokens → the connection → Revoke. Access stops immediately.',
    disconnect_claude: 'In Claude: Customize → Connectors → Atlas → Remove.',
    disconnect_chatgpt: 'In ChatGPT: find Atlas in the Apps (or Plugins) settings and remove it.',
    disconnect_admin: 'If the person who connected the assistant loses admin rights, the connection stops working by itself.',
    disconnectNote: 'Removing it in Claude or ChatGPT does not always revoke access in Atlas. Revoking the connection in Atlas is the reliable way.',
    openTokens: 'Open API tokens',
    openDrafts: 'Open drafts',
    openHelp: 'How to connect Claude or ChatGPT',
    consentTitle: 'Connect an AI assistant',
    consentAsking: '{{client}} is asking for access to the data of «{{organization}}».',
    client_claude: 'Claude',
    client_chatgpt: 'ChatGPT',
    client_local: 'A program on your computer',
    client_other: 'Another application',
    consentHost: 'Access goes to: {{host}}',
    consentClientName: 'The application calls itself «{{name}}»',
    consentLocalWarning: 'This is a program on your computer, for example Claude Code. Allow it only if you just started it yourself.',
    consentOtherWarning: 'Atlas does not know this application. Allow it only if you started the connection yourself and trust the address above.',
    consentScopesTitle: 'What the assistant may do',
    consentScope_read: 'See all data: products, prices, stock, sales, revenue, acceptances and drafts',
    consentScope_read_products: 'See products and prices',
    consentScope_read_stock: 'See stock by warehouse',
    consentScope_read_sales: 'See sales and revenue',
    consentScope_draft_sales: 'Propose sale drafts',
    consentScope_draft_acceptances: 'Propose acceptance drafts',
    consentDraftNote: 'A draft sells nothing and changes no stock or money until you save it yourself in the app. For drafts, tick «See all data» too — otherwise the assistant cannot see your stores and products.',
    consentExpiresTitle: 'How long access lasts',
    consentActor: 'Access will act on your behalf ({{name}}). You can revoke it at any time in Settings → API tokens.',
    consentPickScope: 'Tick at least one permission.',
    allow: 'Allow',
    deny: 'Deny',
    redirecting: 'Returning to {{client}}…',
    noRequest: 'This is where a Claude or ChatGPT connection to Atlas is approved. Start connecting in the assistant itself — it opens this page.',
    blocked_not_admin: 'Only an admin of the organization can connect an AI assistant. Sign in as an admin or ask one.',
    blocked_not_found: 'The connection request was not found. Start connecting again in Claude or ChatGPT.',
    blocked_stale: 'This request has expired — start connecting again in Claude or ChatGPT.',
    decisionError_request_not_pending: 'This request was already handled — start connecting again in Claude or ChatGPT.',
    decisionError_request_expired: 'This request has expired — start connecting again in Claude or ChatGPT.',
    decisionError_mcp_not_enabled_for_organization: 'AI assistant connections are not enabled for your organization yet.',
    decisionError_mcp_disabled: 'AI assistant connections are switched off right now.',
    decisionError_organization_not_on_supabase: 'Connections are only available to organizations already moved to the new Atlas database.',
    decisionError_too_many_active_tokens: 'The organization already has the maximum number of active tokens and connections. Revoke one in Settings → API tokens.',
    decisionError_invalid_scopes: 'These permissions cannot be granted. Start connecting again.',
    decisionError_invalid_expiry: 'Choose how long the connection lasts from the list.',
    decisionError_mcp_access_undetermined: 'Atlas could not check whether your organization can connect an assistant. Try again in a minute.',
    decisionError_organization_access_undetermined: 'Atlas could not check whether your organization can connect an assistant. Try again in a minute.',
    decisionError_forbidden: 'Only an admin of the organization can connect an AI assistant.',
    networkError: 'No connection to the server. Check your internet and try again.',
    genericError: 'Something went wrong. Please try again.',
    retry: 'Retry',
    goHome: 'Go to home',
    connectedThrough_claude: 'Claude connection',
    connectedThrough_chatgpt: 'ChatGPT connection',
    connectedThrough_local: 'Connection from a program on a computer',
    connectedThrough_other: 'AI application connection',
    connectionHost: 'address: {{host}}',
    revokeConnectionText: '{{client}} will lose access to Atlas immediately. To use the assistant again, connect it again.',
  },
  settings: {
    settings: 'Settings',
    apiTokens: 'API tokens',
    agentDrafts: 'AI agent drafts',
    aiAssistants: 'AI assistants: Claude and ChatGPT',
    productCategories: 'Product categories',
    ecommerceProductsTable: 'E-commerce products table',
    loyaltySettings: 'Loyalty program settings',
    marketplaceSettings: 'Online catalog settings',
    productTags: 'E-commerce tags',
    productTag: 'Product tag',
    discountOptions: 'Available discounts',
    suppliers: 'Suppliers',
    users: 'Employees',
    inactiveUsers: 'Inactive employees',
    roles: 'Roles and access',
    stores: 'Branches',
    wallets: 'Wallets',
    paymentMethods: 'Payment methods',
    purchaseMethods: 'Purchase methods',
    priceTypes: 'Price Types',
    productUnits: 'Product units of measure',
    organizationSettings: 'Organization settings',
    saleSettings: 'Sale Settings',
    writeOffReasons: 'Write-off reasons',
    returnReasons: 'Return reasons',
    recurringSpendings: 'Monthly expenses',
    adminSpendingCategories: 'Admin spending categories',
    spendingCategories: 'Seller spending categories',
    billing: 'Pricing and Billing',
    checkForUpdates: 'Check for updates',
    checkingForUpdates: 'Checking for updates',
    version: 'Version',
    resetData: 'Reset data',
    appearance: 'Appearance',
    systemTheme: 'System',
    lightTheme: 'Light',
    darkTheme: 'Dark',
    withoutFiscalization: 'Without fiscalization',
    atLeastOnePurchaseMethodError: 'There must be at least one active purchase method in the organization',
    atLeastOnePriceTypeError: 'At least one price type is required',
    onePriceTypeMustBeDefault: 'One price type must be set as default',
    duplicatePriceTypeIds: 'Duplicate price type IDs detected',
    allPriceTypesMustHaveNames: 'All price types must have names',
    priceTypesSaved: 'Price types saved successfully',
    errorSavingPriceTypes: 'Error saving price types',
    cannotDeleteRetailPriceType: 'Cannot delete the retail price type',
    cannotDeleteCashPaymentMethodError: 'Cannot delete cash payment method',
    destinationWalletsNotFilledError: 'Select a destination account for active branches',
    walletTiedToPaymentMethodError: 'Account is tied to a payment method, first untie it from the payment method and try again. Tied payment methods: {{paymentMethods}}',
    uniqueIdError: 'ID must be unique',
    priceTypesHint: 'Configure additional price types for your products, e.g. wholesale, in installments/BNPL, on sale, etc. After adding a new price type here a new field will appear when editing the product where you can specify these prices. When creating a sale you will be able to choose which price to use for the sale.',
    autoCalculated: 'Calculated automatically',
    priceTypeName: 'Price Type Name',
    priceTypeId: 'Price Type ID',
    enterName: 'Enter name',
    enterId: 'Enter ID',
    scope: 'Scope',
    perStore: 'Separate prices per store',
    organizationWide: 'Common price organization-wide',
    isDefault: 'Default Price Type',
    isRequired: 'Required Price',
    deletePriceType: 'Delete Price Type',
    confirmDeletePriceType: 'Are you sure you want to delete this price type?',
    addPriceType: 'Add Price Type',
    newPriceType: 'New Price Type',
    editPriceType: 'Edit Price Type',
    noPriceTypes: 'No Price Types',
    createFirstPriceType: 'Create your first price type to get started',
    priceTypeNameRequired: 'Price type name is required',
    priceTypeSaved: 'Price type saved successfully',
    priceTypeDeleted: 'Price type deleted successfully',
    errorSavingPriceType: 'Error saving price type',
    errorDeletingPriceType: 'Error deleting price type',
    priceCalculation: 'Price Calculation',
    autoCalculateFromDefault: 'Auto-calculate from default price',
    autoCalculateFromSalePrice: 'Auto-calculate from sale price (default price)',
    manualPriceHint: 'If autocalculation is disabled, you should manually set the price for each product',
    calculationType: 'Calculation Type',
    percentage: 'Percentage',
    multiply: 'Multiply',
    adjust: 'Add/subtract',
    minQuantity: 'Minimum Quantity',
    percentageHint: 'E.g., 10 means +10%, -10 means -10%',
    multiplierHint: 'E.g., 1.2 means 20% more, 0.8 means 20% less',
    adjustHint: 'Positive to add, negative to subtract (e.g., 100 or -50)',
    multiplier: 'Multiplier',
    amount: 'Amount to add/subtract',
    autoRules: 'Auto-Selection Rules',
    enableAutoRules: 'Enable Auto Rules',
    ruleType: 'Rule Type',
    none: 'None',
    quantity: 'Based on quantity of products in cart',
    paymentMethod: 'Based on payment method',
    client: 'Based on client',
    paymentMethodIds: 'Payment Method IDs',
    paymentMethodIdsHint: 'Comma-separated payment method IDs',
    selectRuleTypes: 'Select Rule Types',
    selectPaymentMethods: 'Select Payment Methods',
    cartTotal: 'Based on cart total',
    minCartAmount: 'Minimum Cart Amount',
    clientRuleHint: 'You can set a preferred price type for a client when creating/editing a client. This price will be automatically applied when a client is selected in a new sale',
    name: 'Name',
    iconAndText: 'Icon and text',
    textUnderIcon: 'Text under icon',
    comission: 'Commission',
    category: 'Category',
    cash: 'Cash',
    card: 'Non-cash',
    settingsByStore: 'Settings by branches',
    destinationWallet: 'Destination account',
    categorySortHint: 'Category order is saved automatically. After changing the order, reload the page or the app to see the changes on the New Sale page.',
    // ATL-1892 — a reorder is saved as one batch, so a failure changes no category at all.
    categoryReorderFailed: 'The category order could not be saved. Nothing was changed. Please try again, or contact support if it keeps happening.',
    newCategory: 'New category',
    moveToCategory: 'Which category to move products from this category to',
    modifiers: 'Product modifiers',
    onlyOneUnitError: 'Cannot delete the only unit of measure',
    newUnit: 'New unit of measure',
    shortName: 'Short name',
    noPriceModificators: 'No markups or discounts',
    value: 'Value',
    priceModificatorsHint: 'You can add a markup or discount to the total bill when choosing this purchase method, for example - service charge, tax, discount for takeaway orders... Specify a positive or negative value in percent. If -10, then it will be a 10 percent discount, if 20, then it will be a 20 percent markup.',
    priceModificators: 'Markups and discounts',
    downloadingUpdateHint: 'Downloading update, the app will restart soon',
    noUpdates: 'No updates',
    noUpdateForWebError: 'This feature is for the mobile app. To update the web version, reload the page',
    commonBetweenStores: 'Common',
    legal: 'Legal',
    helpCenterLink: 'https://atlas-app.notion.site/745b5f835e9144ecb022d729e6b2e23b?v=8920d6f3e6064ab9842cc81628c5ada8&pvs=4',
    discountInstructions: 'Add percentage discount options that will be available to choose from on New Sale screen',
    printSettings: 'Print settings',
    invoiceTitle: 'Invoice title',
    invoiceSubtitle: 'Invoice subtitle',
    imagesSection: 'Images',
    logoImage: 'Logo (fixed position)',
    additionalImage: 'Additional image (at bottom)',
    additionalImageWidth: 'Additional image width (px)',
    includeFields: 'Include fields',
    includeVAT: 'Include VAT',
    vatRate: 'VAT rate (%)',
    additionalText: 'Additional text at the bottom',
    signatureFields: 'Signatures',
    removeField: 'Remove field',
    imagePositionOptions: {
      'top-left': 'Top left',
      'top-right': 'Top right',
      'bottom-left': 'Bottom left',
      'bottom-right': 'Bottom right',
      'none': 'None'
    },
    fieldOptions: {
      invoiceNumber: 'Invoice number',
      date: 'Date',
      supplier: 'Supplier',
      buyer: 'Buyer',
      clientPhone: 'Client phone',
      clientAddress: 'Client address',
      itemsTable: 'Items table',
      productImages: 'Product images',
      totalAmount: 'Total amount',
      amountInWords: 'Amount in words',
      signatures: 'Signatures',
      qrCode: 'QR Code'
    },
    printTemplates: 'Print templates',
    createTemplate: 'Create template',
    editTemplate: 'Edit template',
    deleteTemplate: 'Delete template',
    templateName: 'Template name',
    selectStore: 'Select branch',
    pageSize: 'Page size',
    selectPageSize: 'Select page size',
    customWidth: 'Width (mm)',
    pagePadding: 'Page padding (px)',
    globalTemplate: 'Global template',
    storeTemplate: 'Branch template',
    setAsDefault: 'Set as default',
    defaultTemplate: 'Default template',
    templateForStore: 'Template for {{storeName}}',
    noTemplates: 'No templates created',
    createFirstTemplate: 'Create first template',
    confirmDeleteTemplate: 'Delete template "{{templateName}}"?',
    templateDeleted: 'Template deleted',
    templateSaved: 'Template saved',
    templateCreated: 'Template created',
    templateType: 'Template type',
    templateTypes: {
      sale: 'Sale',
      supply: 'Supply',
      supplyOrder: 'Supply Order'
    }
  },
  manufactures: {
    manufactures: 'Manufacturing',
    manufacture: 'Manufacture',
    manufacturedDate: 'Manufacturing date',
    quantity: 'Quantity',
    batchNumber: 'Batch number',
    batchNumberPlaceholder: 'Optional',
    mainHintAction: 'Instructions',
    mainHintLink: 'https://www.notion.so/atlas-app/What-is-Manufacture-module-b543d903c7404428809ce7e8d3c06898?pvs=4#1887ceb1e04f80649832eb0955fa9da6',
    cashier: 'Cashier',
    ingredientUnitCosts: 'Ingredient unit costs',
    ingredients: 'Ingredients (qty x price = total)',
    ingredientsCost: 'Ingredients total cost',
    manufactureId: 'Manufacture ID',
    productId: 'Product ID',
    ingredientIds: 'Ingredients by ID (ID: qty per produced unit)',
    totalSum: 'Total sum',
  },
  spendings: {
    spendings: 'Expenses',
    spending: 'Expense',
    monthlySpendings: 'Monthly expenses',
    newMonthlySpending: 'New monthly expense',
    allStores: 'General/Other',
    name: 'Name',
    amount: 'Amount',
    startDate: 'Start date',
    hasEndDate: 'Specify end date',
    endDate: 'End date',
    typeRecurring: 'Type - monthly',
    instructions: 'Filling instructions',
    category: 'Category',
    type: 'Type',
    source: 'Source',
    details: 'Details',
    adminSpendingCategories: 'Admin spending categories',
    spendingCategories: 'Seller spending categories',
    OPEX: 'Operating expenses (daily)',
    CAPEX: 'Capital expenditures (large and unusual - repairs, equipment purchase)',
    notANumberError: 'Amount should be a number more than 0',
  },
  shift: {
    shift: 'Shift',
    shiftStats: 'Shift report',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    openShift: 'Open shift',
    closeShift: 'Close shift',
    endDayAmount: 'End of day amount',
    logout: 'Log out',
    close: 'Close',
    amount: 'Amount',
    ofdAmountError: 'Cash register amounts do not match OFD amounts',
    ofdSalesNotSentError: 'Unsent OFD sales found',
    ofdSalesNotMatchError: 'Sales amount does not match OFD receipts amount',
    shiftClosed: 'Shift closed',
    pleaseOpenShift: 'Please open the shift',
    startCashboxAmount: 'Cash in cashbox at the start of the shift',
    employeesOnShift: 'Employees on shift',
    open: 'Open',
    fullDay: 'Full day',
    fromTo: 'from {{from}} to {{to}}',
    saving: 'Saving...',
    add: 'Add',
    workingHours: 'Working hours',
    shiftInfo: 'Shift information',
    shiftOpenedTime: 'Shift opened',
    shiftClosedTime: 'Shift closed',
    cashInCashbox: 'Cash in cashbox',
    startAmount: 'Start amount',
    withdrawals: 'Withdrawals',
    returns: 'Returns',
    sales: 'Sales',
    spendings: 'Spendings',
    paidSupplies: 'Paid supplies',
    deposits: 'Deposits',
    total: 'Total',
    salesByEmployees: 'Sales by employees',
    getOfdStats: 'Get OFD data',
    ofdStats: 'OFD data',
    cashSales: 'Cash sales',
    cardSales: 'Card sales',
    cashReturns: 'Cash returns',
    cardReturns: 'Card returns',
    withdrawalsAndDeposits: 'Withdrawals/Deposits',
    newSpending: 'Spending',
    cancelCloseShift: 'Cancel closing',
    closeShiftCTA: 'Close shift',
    byCash: 'By cash',
    openAmountFact: 'Opening - Fact',
    cashEndAmount: 'Closing - Fact',
    systemEndAmount: 'Closing - Should be',
    shiftNotClosed: 'Shift not closed',
    alreadyClosed: 'This shift has already been closed',
    duplicateOpens: 'This shift was opened {{count}} more time(s): extra openings are recorded',
    closedWithoutAmounts: 'Shift closed without counted amounts',
    duplicateCloses: 'This shift was closed {{count}} more time(s): extra closings are recorded',
    cash: 'Cash',
    amountShouldBe: 'Should be',
    amountFact: 'Fact',
    otherPayments: 'Transfer payments and others',
    today: 'Today',
    previousDays: 'Previous dates',
    notANumberError: 'Amount should be a number',
    deleteFailed: 'Could not delete. Please try again',
  },
  transfers: {
    transfers: 'Transfers',
    transfer: 'Transfer',
    products: 'Products',
    inputBarcode: 'Enter barcode',
    name: 'Name',
    quantity: 'Quantity',
    fromStore: 'From branch',
    toStore: 'To branch',
    total: 'Total',
    addThroughBarcodeHint: 'Add products through search or by scanning a barcode',
    inStockFromStore: 'In stock (from)',
    inStockToStore: 'In stock (to)',
  },
  clientOrders: {
    clientOrders: 'Client orders',
    clientOrder: 'Order',
    statusNew: 'New',
    statusContacted: 'Contacted the client, waiting for confirmation',
    statusConfirmed: 'Order confirmed, awaiting delivery',
    statusDelivered: 'Order delivered',
    statusCanceled: 'Order canceled',
    name: 'Name',
    date: 'Date',
    phone: 'Phone',
    deliveryType: 'Delivery method',
    deliveryAddress: 'Delivery address',
    delivery: 'Delivery',
    pickup: 'Pickup',
    now: 'Now',
    status: 'Status',
    processed: 'Processed',
    notProcessed: 'Active',
    writeOnWhatsapp: 'Write on WhatsApp',
    convertIntoSale: 'Process sale',
    noOrders: 'No active orders',
    showActive: 'Show only active',
  },
  payments: {
    paymentStats: 'Money / Cash Flow',
    loadError: 'Could not load the report. The period\'s figures were not calculated — check your connection and try again.',
    loadRetry: 'Retry',
    paymentTransactions: 'Financial transactions',
    paymentTransaction: 'Financial transaction',
    payments: 'Payments',
    transactions: 'Transactions',
    overview: 'Overview',
    saleAmount: 'Sales amount: ',
    saleAmount_description: 'This is the total value of all sales made during the selected period, without considering if payment has been received.',
    currentPeriodSalePayments: 'Sale Payments for the current period: ',
    currentPeriodSalePayments_description: 'This shows how much cash has been received specifically for sales that were made *within* the selected date range. It excludes payments received for sales made before this period.',
    totalSalePayments: 'Total Sale Payments: ',
    totalSalePayments_description: 'This is the total cash that has actually come in from sales. It includes payments for sales made in the current period as well as payments received in the current period for sales made in previous periods (e.g., an unpaid payment for a past sale).',
    upcomingAccountsReceivable: 'Accounts receivable: ',
    upcomingAccountsReceivable_description: 'This is the total amount of money that customers still owe you for sales made on credit or via installment plans, across all time (both current and past sales).',
    complexSales: 'Complex sales',
    unpaidComplexSalesList: 'Unpaid complex sales:',
    unpaidSupplies: 'Unpaid supplies',
    totalUnpaidSupplies: 'Total unpaid supplies: ',
    totalCreditSalesAmountCurrentPeriod: 'Total credit sales for the current period: ',
    totalCreditSalesPaidAmountCurrentPeriod: 'Total paid amount for the current period: ',
    totalCreditSalesPaidAmountPreviousPeriod: 'Total paid amount for the previous period: ',
    totalCreditSalesPaidAmount: 'Total paid amount: ',
    totalAccountsReceivable: 'Accounts receivable: ',
    creditSalesAmount: 'Credit sales: ',
    creditSalesPaidAmount: 'Paid amount: ',
    accountsReceivable: 'Accounts receivable: ',
    currentPeriodPayments: 'Payments for the current period: ',
    currentPeriodPayments_description: 'This is the sum of all cash that has gone out of the business for various expenses (salaries, supplier payments, recurring costs, other spendings, bank fees) during the selected period.',
    currentBalance: 'Balance: ',
    currentBalance_description: 'This is your operational profit or loss for the selected period based on actual cash flow. It shows the difference between cash received from actual current period sales and total actual expenses paid in the current period.',
    upcomingPayments: 'Upcoming payments for the current period: ',
    upcomingPayments_description: 'This represents the total amount of money the business still needs to pay out for expenses that have been incurred (salaries, supplies, recurring costs) but have not yet been paid within the current period. It is counted separately for each employee, supplier and recurring cost: overpaying one payee does not reduce what you owe the others. Only amounts accrued for the selected period are included — salary debts and advances from earlier periods (the «Total balance» in the Salaries section) and supplies still unpaid from earlier periods («Total unpaid supplies» in the Suppliers section) are not.',
    upcomingBalanceCurrentPeriod: 'Expected balance for the current period: ',
    upcomingBalanceCurrentPeriod_description: 'This is your projected cash balance if all expected incoming payments from customers (for all sales) are received and all upcoming expense payments for the current period are made.',
    previousPeriodPayments: 'Payments for previous periods: ',
    previousPeriodPayments_description: 'This is the total amount of cash paid out during the current selected period for expenses that were actually incurred in previous periods (e.g., paying an overdue supplier invoice from last month).',
    futurePeriodPayments: 'Payments for future periods: ',
    futurePeriodPayments_description: 'This is the total amount of cash paid out during the current selected period for expenses that will be incurred in future periods. It excludes payments for expenses that were actually incurred in previous periods (e.g., paying an overdue supplier invoice from last month). It also excludes payments for expenses that will be incurred in the current period (e.g., paying an overdue supplier invoice from last month).',
    totalCreditFuturePeriod: 'Paid for the future period: ',
    upcomingBalanceWithPreviousPeriodPayments: 'Balance including payments for the previous period: ',
    upcomingBalanceWithPreviousPeriodPayments_description: 'This is the ultimate projected cash position, taking into account the current operating balance, all upcoming payments and receivables, and adjustments for payments related to past and future periods.',
    paymentsForCurrentPeriodSales: "Payments for Current Period Sales: ",
    paymentsForPreviousPeriodSales: "Payments for Previous Period Sales: ",
    salaries: 'Salaries',
    totalDebit: 'Accrued: ',
    totalCredit: 'Paid in total: ',
    totalCreditPreviousPeriod: 'Paid for the previous period: ',
    totalCreditCurrentPeriod: 'Paid for the current period: ',
    balance: 'Balance for the current period: ',
    allTimeBalance: 'Total balance: ',
    currentPeriodBalance: 'Current period balance: ',
    currentPeriod: 'Current period',
    pay: 'Pay',
    suppliers: 'Suppliers',
    suppliersTotalDebit: 'Goods received: ',
    monthlySpendings: 'Monthly expenses',
    otherPayments: 'Other expenses',
    spendingPayments: 'One-time expenses: ',
    bankPercent: 'Bank commission: ',
    cashboxShiftDifference: 'Difference in shift closures: ',
    salaryPayment: 'Salary payment',
    workingHourPayment: 'Salary payment',
    supplyPayment: 'Payment to suppliers',
    recurringSpendingPayment: 'Payment of monthly expenses',
    spendingPayment: 'Expense payment',
    // ATL-987: PaymentTransactionsScreen renders t('payments.' + linkedDocType + 'Payment').
    // A refund is type='expense', so it reaches that renderer — and NO key existed for it, in
    // either locale, so the row showed the raw string 'payments.returnPayment' to the merchant.
    // Keyed on 'return' because that is what BOTH stores now carry: it is what Firestore holds
    // (firebase.ts:1899, the source the whole non-cutover fleet still reads) and, after ATL-987,
    // what Supabase holds too. A 'sale_returnPayment' key could only ever have covered the
    // handful of orgs reading Supabase.
    returnPayment: 'Customer refund',
    category: 'Category',
    destination: 'To whom',
    amount: 'Amount',
    sourceWallet: 'Source',
    paymentDate: 'Payment date',
    paymentRange: 'Period for which payment is made',
    details: 'Details',
    supplyPaymentRangeInfo: 'All receptions up to this date inclusive will be marked as paid',
    stats: 'Report',
    byCreatedDate: 'By creation date',
    byPaymentPeriod: 'By payment period',
    totalPaymentAmount: 'Total payment amount: ',
    todayEmptyPayments: 'There were no payments today',
    foundError: 'Found an error in the report?',
    foundErrorDescription: 'Choose an employee and click recalculate to recalculate the balance of the employee for all time',
    recalculate: 'Recalculate',
  },
  complexSales: {
    complexSales: 'Complex sales',
    complexSale: 'Complex sale',
    addProduct: 'Search for goods/services',
    addEmptyRow: 'Add an empty row',
    totalPurchaseSum: 'Total cost price',
    totalSaleSum: 'Total price',
    expectedMargin: 'Margin',
    paymentMethod: 'Payment method',
    commentText: 'Comment',
    expectedProfit: 'Expected profit',
    itemsList: 'List of expenses',
    emptyItems: 'No expenses. Add expenses through Search from the database of goods/services or manually through an empty row',
    name: 'Name',
    salePrice: 'Price',
    purchasePrice: 'Cost price',
    packagePrice: 'Additional expenses',
    quantity: 'Quantity',
    itemsTotals: 'Total for goods/services',
    templates: 'Templates',
    finalPrice: 'Price for the customer',
    emptyTemplate: 'Empty template',
    editTemplate: 'Edit template',
    newTemplate: 'New template',
    editComplexSale: 'Editing a complex sale',
    newComplexSale: 'New complex sale',
    showActive: 'Show only active',
    add: 'Add',
    newComment: 'New comment',
    new: 'New',
    inProgress: 'In progress',
    finished: 'Finished',
    canceled: 'Canceled',
    template: 'Template',
    createdDate: 'Creation date',
    client: 'Client',
    status: 'Status',
    comments: 'Comments',
    dateAndAuthor: 'Date/author',
    comment: 'Comment',
    deletedAuthor: 'Deleted',
    payments: 'Payments',
    newPayment: 'New payment',
    amount: 'Amount',
    description: 'Description',
    totalPaid: 'Total paid',
    remainingAmount: 'Remaining amount',
    includeSales: 'Include simple sales',
  },
  printStickers: {
    printStickers: 'Print stickers',
    addProductSticker: 'Add product',
    printSettings: 'Sticker settings',
    worksOnWebError: 'Sticker printing is currently only available from a computer',
    stickerDate: 'Date on the sticker',
    products: 'Products',
    weight: 'Weight',
    preview: 'Preview',
    stickerSettings: 'Sticker settings',
    printStickersCTA: 'Print stickers',
    stickerHeight: 'Sticker height',
    generalFontSize: 'General font size',
    priceFontSize: 'Price font size',
    printDateOnSticker: 'Print date on sticker',
    print: 'Print',
    doNotPrint: 'Do not print',
    stickerHeightHint: '150 for 40mm paper height, 113 for 30mm',
    additionalPricesToShow: 'Additional prices to show on stickers',
    additionalPricesToShowHint: 'Select which additional price types should be displayed on stickers. Only prices that are configured for products will be shown.',
    printFailed: 'Could not print the stickers. Check your printer and try again.',
    nothingToPrint: 'There are no stickers to print.',
  },
  profile: {
    profile: 'Profile',
    chooseStore: 'Choose a branch',
    email: 'Email',
    logout: 'Log out'
  },
  salary: {
    salary: 'Salary',
    periodMissing: 'Period not set',
    chooseSameMonthError: 'Select dates only in one month',
    fromToHours: 'from {{start}} to {{end}}',
    employee: 'Employee',
    salaryType: 'Salary type',
    bonusType: 'Bonus type',
    withoutBonuses: 'Without bonuses',
    hoursQuantity: 'Working hours this period',
    daysQuantity: 'Number of working days this period',
    monthlySales: 'Sales for this period (minus returns)',
    salaryAccrued: 'Salary accrued for this period',
    salaryPaid: 'Salary paid for this period',
    allTimeSalaryCredited: 'Total salary credited',
    allTimeSalaryPaid: 'Total salary paid',
    allTimeBalance: 'Total balance',
    salesPlan: 'Sales plan',
    baseline: 'Baseline goal',
    bonus: 'bonuses',
    factSales: 'Actual sales for {{count}} day/days',
    tillBaseline: 'To the baseline goal',
    daily: 'per day',
    until: 'Until',
    bonuses: 'Bonuses',
    workingHours: 'Working hours',
    amount: 'Amount',
    noDataForMonth: 'No data for the month',
    payouts: 'Payouts',
    currentPeriodBalance: 'Current period balance',
    foundError: 'Found an error in the report?',
    foundErrorDescription: 'Click recalculate to recalculate the balance of the employee',
    recalculate: 'Recalculate',
  },
  checklist: {
    checklist: 'Checklist',
    shift: 'Shift',
    openShift: 'Open shift',
    wipeTheWindows: 'Wipe the windows',
    washTheFloor: 'Wash the floors',
    cleaning: 'Cleaning',
    checklistNotAvailableForToday: 'Change the date to yesterday and try again',
    addTask: 'Add task',
    editTask: 'Edit task',
    type: 'Type',
    oneTimeTask: 'One-time task',
    dailyTask: 'Daily task',
    section: 'Section',
    positionBefore: 'Position (before)',
  },
  updates: {
    updates: 'Updates',
    deleteProduct: 'Delete product',
    newProduct: 'Create product',
    updateProductPrices: 'Change product price',
    deleteSale: 'Delete sale',
    deleteWorkingHour: 'Delete from shift',
    purchasePrice: 'Purchase price',
    unknownDate: 'date unknown',
  },
  operations: {
    totalSum: 'Total amount: {{totalSum}}',
    filterUnavailable: 'The filter for this list could not be applied. Nothing is shown, rather than risk showing the wrong figures. Update the app or contact support.'
  },
  marketingLists: {
    marketingLists: 'Mailings',
    marketingList: 'Mailing',
    createMarketingList: 'New mailing',
    chooseProduct: 'Choose product',
    byProductCategory: 'By product category',
    byProduct: 'By product',
    saveList: 'Save list',
    writeOnWhatsapp: 'Write on WhatsApp',
    status: 'Status',
    completed: 'Completed',
    notCompleted: 'Not completed',
    complete: 'Complete',
  },
  stats: {
    stats: 'Reports',
    productStats: 'Product report',
    productsToday: 'Products for today',
    receipts: 'Receipts',
    quantityShort: 'Qty',
    amount: 'Amount',
    marginShort: 'Margin',
    today: 'Today',
    name: 'Name',
    category: 'Category',
    supplier: 'Supplier',
    sales: 'Sales',
    salesMargin: 'Sales margin',
    loyalClients: 'Loyal clients',
    returns: 'Returns',
    supplies: 'Supplies',
    writeOffs: 'Write-offs',
    salaryAmount: 'Salary for the day',
    spendings: 'Expenses',
    inStockProducts: 'Products in stock',
    monthlySpendings: 'Monthly expenses',
    profitForDay: '~ Profit for the day',
    saleQuantity: 'Sales qty',
    saleAmount: 'Sales amount',
    writeOffQuantity: 'Write-offs qty',
    writeOffAmount: 'Write-offs amount',
    supplyQuantity: 'Supplies qty',
    supplyAmount: 'Supplies amount',
    margin: 'Margin',
    profit: 'Profit',
    checkQuantity: 'Receipts qty',
    purchaseAmount: 'Cost amount',
    packageAmount: 'Packaging cost',
    columns: 'Columns',
    byProductCategory: 'By product categories',
    bySupplier: 'By suppliers',
    byProduct: 'By products',
    foundError: 'Found an error in the report?',
    foundErrorDescription: 'This could be due to an unstable internet connection. Select the date from which the error started.',
    recalculate: 'Recalculate',
    pAndL: 'Profit / P&L',
    noCategory: 'No category',
    netProductSales: 'Sales (Net Product Sales)',
    costOfSales: 'Cost of Goods Sold (Cost of Sales)',
    paidByBonuses: 'Paid by bonuses',
    grossIncome: 'Margin (Gross Income)',
    writeOffRevisionReturnsAmount: 'Returns, write-offs, shortages',
    revisionDifferenceAmount: 'Revision differences',
    cashboxDifferenceAmount: 'Cash register discrepancies',
    salary: 'Salaries',
    bankPercent: 'Bank commission',
    netIncome: 'Operating profit (Net Income)',
    capexSpendings: 'Capital expenditures',
    pureProfit: 'Net profit',
    transfers: 'Transfers',
    startProductAmount: 'Product cost at the beginning',
    endProductAmount: 'Product cost at the end',
    productAmountDifference: 'Difference in product cost',
    stockSnapshotUnavailable: 'no data',
    stockSnapshotsMissing: 'Stock was not recorded for {{count}} day/store combinations — product cost not calculated',
    stockSnapshotsMissingOpening: 'Stock was not recorded for {{count}} day/store combinations — product cost at the beginning not calculated',
    stockSnapshotsMissingClosing: 'Stock was not recorded for {{count}} day/store combinations — product cost at the end not calculated',
    stockSnapshotsUnreadable: 'Opening and closing stock could not be read for this range — product cost not calculated',
    stockSnapshotUnknownCells: 'Stock is unknown for {{count}} product/store figures — product cost is understated by whatever they hold',
    stockDifferenceNotComparable: '{{count}} of them are counted at only one end of the period, so the difference is not a like-for-like comparison — treat it as unreliable',
    groupBy: 'Group by',
    byPaymentMethod: 'By payment method',
    byPurchaseMethod: 'By purchase method',
    byEmployee: 'By employee',
    returnQuantity: 'Number of returns',
    salesAverageAmount: 'Average receipt',
    saleQuantityFull: 'Number of sales',
    salesStats: 'Sales report',
    fullPeriod: 'For the entire period',
    byDays: 'By days',
    salesStatsDescription: 'Sales by days and payment methods',
    allStats: 'All reports',
    profitStats: 'Profit / P&L',
    profitStatsDescription: 'Profit and loss report',
    paymentStats: 'Money / Cash flow',
    paymentStatsDescription: 'Cash flow report',
    shiftStats: 'Shift report',
    shiftStatsDescription: 'Information about past shifts and shortages',
    productStatsDescription: 'Which products and categories sell best',
    writeOffStats: 'Write-off report',
    writeOffStatsDescription: 'Which products and categories are written off the most',
    revisionStats: 'Revision report',
    revisionStatsDescription: 'Consolidated revision report',
  },
  clients: {
    clients: 'Clients',
    client: 'Client',
    name: 'Name',
    phone: 'Phone',
    address: 'Address',
    bonusValue: 'Bonuses',
    bonusLevel: 'Bonus level',
    loyaltyDiscount: 'Loyalty discount',
    punchCard: 'Punch card',
    preferredPriceType: 'Preferred Price Type',
    none: 'None',
    salesValue: 'All-time Sales: {{salesQuantity}} sales for {{salesSum}}',
    profitValue: 'All-time Profit: {{profit}}',
    averageSalesFrequency: 'Average purchase frequency - every {{value}} days',
    addingBonuses: 'Adding bonuses',
    purchases: 'Purchases',
    clientNotFoundShowingSnapshot: 'Client not found (possibly deleted) — showing the details saved with the sale',
    clientRefreshFailed: 'Could not refresh the client — showing the details saved with the sale',
    noClientPurchases: 'This client has no purchases yet',
    purchasesLoadError: "Couldn't load this client's purchases. Close the card and open it again.",
    operationsLoadError: "Couldn't load this client's operations history.",
    topProducts: 'Top products (receipts, qty, amount)',
    addBonuses: 'Add bonuses',
    phoneAndName: 'Phone or name',
    lastPurchaseDate: 'Select the period of the last purchase',
    registrationDate: 'Select the registration period',
    searchClients: 'Search clients',
    byPhoneAndName: 'By phone number or name',
    byProducts: 'By purchased products',
    byLastPurchaseDate: 'By last purchase date',
    byRegistrationDate: 'By registration date',
    count: 'Count - {{count}}',
    writeOnWhatsapp: 'Write on WhatsApp',
    manualBonusChange: 'Manual bonus change',
    operations: 'Operations',
    allClients: 'All Clients',
    editClient: 'Editing client',
    invalidPhoneNumber: 'Invalid phone number format',
    saving: 'Saving...',
    updateSuccess: 'Client updated successfully. Changes will be reflected in a minute.',
    clientStats: 'Client Statistics',
    totalClients: 'Total Clients',
    newClients: 'New Clients',
    activeClients: 'Active Clients',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
  },
  login: {
    // WA-ONBOARD-001 — the WhatsApp activation opt-in shown beneath the phone field at signup.
    // Consent is consent to what was on screen, so this wording is pinned by
    // utils/__tests__/whatsappOnboardingConsent.test.js: it must name WhatsApp, name Atlas,
    // say what the messages are for, and say how to stop. Changing it means bumping
    // WHATSAPP_ONBOARDING_CONSENT_SOURCE in the backend, so a stored consent always says which
    // text was agreed to.
    whatsappOptIn: 'Send me Atlas setup help on WhatsApp - tips for getting my store running.',
    whatsappOptInDisclosure: 'We will write to the number above. Reply STOP at any time to unsubscribe.',
    login: 'Login',
    signUp: 'Sign Up',
    newOrgSignUp: 'New Company Registration',
    passwordReset: 'Password Recovery',
    email: 'Email',
    password: 'Password',
    resetPassword: 'Reset Password',
    resetPasswordSuccess: 'A password reset email has been sent. If you did not receive it, please check your Spam folder. The password reset link is valid for 10 minutes',
    loginCTA: 'Log In',
    emailRequired: 'Enter email',
    passwordRequired: 'Enter password',
    userNotFound: 'User not found',
    wrongPassword: 'Incorrect password',
    invalidEmail: 'Invalid email',
    tooManyRequests: 'Too many requests. Please try again later',
    userDisabled: 'User is blocked',
    networkRequestFailed: 'Internet is not available',
    validateEmailError: 'Enter a valid email',
    passwordLengthError: 'Password must be at least 6 characters',
    phoneLengthError: 'Enter a valid phone number',
    userInfo: 'User Information',
    name: 'Name',
    phone: 'Phone',
    orgInfo: 'Organization Information',
    orgName: 'Organization Name',
    currency: 'Currency',
    businessType: 'Business Category',
    fillInOtherBusinessType: 'Enter another business category',
    clientType: 'Your client category',
    employeeCount: 'Number of employees',
    branchCount: 'Number of your branches / sales points',
    goalOfd: 'Online cash register and OFD integration',
    goalAccounting: 'Accounting',
    goalInvoicing: 'Issue invoices and other documents',
    goalDocuments: 'Electronic documents and signatures',
    goalTodo: 'Keep a to-do list for the company',
    goalNone: 'None of the above',
    priorExperienceNo: 'Did not keep records',
    priorExperiencePaper: 'Kept records in a notebook',
    priorExperienceExcel: 'Excel / other spreadsheets',
    priorExperienceSpecific: 'Industry solutions for automation (for stores/restaurants/manufacturing)',
    priorExperience1c: '1C and other accounting systems',
    setupOptionNo: 'I like to figure things out myself, I don\'t need help',
    setupOptionPartial: 'I will try to figure it out myself, but help wouldn\'t hurt',
    setupOptionFull: 'I don\'t want to figure it out myself, I need help with the setup',
    trafficSourceSocial: 'Instagram / Facebook / Social networks',
    trafficSourceYoutube: 'Youtube',
    trafficSourceWebSearch: 'Search in Google and other search engines',
    trafficSourceAppstore: 'Stumbled upon in App Store / Google Play',
    trafficSourceRecommendation: 'Recommendation from friends',
    trafficSourceOther: 'Other',
    shopOffline: 'Store',
    delivery: 'Delivery',
    admin: 'Admin',
    cashier: 'Cashier',
    universalModifiers: 'Universal modifiers',
    testProduct: 'Test product',
    adminSpendingCategory1: 'Maintenance and service',
    adminSpendingCategory2: 'Online advertising',
    spendingCategory1: 'Bags',
    spendingCategory2: 'Water, tea, sugar...',
    recurringSpending1: 'Rent',
    writeOffReasonWasted: 'Spoiled',
    writeOffReasonInternalUse: 'For company needs',
    writeOffReasonGift: 'As a gift to customers',
    returnReasonMistake: 'Bought by mistake',
    returnReasonNotLike: 'Did not like the product',
    returnReasonBadGood: 'Product is spoiled',
    checklistHeader1: 'Cleaning',
    checklistHeader2: 'Shift',
    checklistTask1: 'Wipe the showcase',
    checklistTask2: 'Mop the floors',
    checklistTask3: 'Open the shift in the cash register',
    goalsAndSettings: 'Goals and Settings',
    goals: 'Goals',
    priorExperienceQuestion: 'How did you previously keep records',
    setupOptionQuestion: 'Do you need help with setting up the app',
    trafficSourceQuestion: 'And the last question - how did you find out about us ☺️',
    register: 'Register',
  },
  onboarding: {
    registration: 'Registration',
    registrationDescription: '',
    sale: 'Conduct a test sale',
    saleDescription: 'To do this, close this popup, in the main menu select New Sale -> Add Product, choose a payment method -> Press Done',
    complexSale: 'Conduct a test complex sale',
    complexSaleDescription: 'Complex sales are relevant for businesses that deal with the sale of complex services. Their sales often differ in their price and expenses, unlike the sales of standard goods and catering. For example - manufacturing a custom product, website development, legal service... To do this, close this popup, in the main menu select Complex Sales -> Plus sign in the top right corner -> Add an empty line -> Fill in the other fields, choose a payment method -> Press Done',
    saleReport: 'See changes in sales reports',
    saleReportDescription: 'After making a sale, you can notice that the numbers at the top of the main menu have been updated. Next, you can view your first sales report. To do this, go to the Main Menu -> Reports -> Sales Reports.',
    productStock: 'See changes in Product Stocks',
    productStockDescription: 'After making a sale, you can notice that the quantity of the product has decreased. To do this, go to the Main Menu -> Product Stocks. Since the quantity of the product was 0 at the beginning, it went into the negative due to the sale.',
    saleHistory: 'View Sales History and delete a sale',
    saleHistoryDescription: 'You can also see the sale you made in the Sales History. It can also be immediately deleted there. To do this, go to the Main Menu -> Sales History -> Select a sale -> Return -> Delete',
    complexSaleHistory: 'View Sales History and delete a sale',
    complexSaleHistoryDescription: 'You can also see the sale you made in the list of Complex Sales. It can also be immediately deleted there. To do this, go to the Main Menu -> Complex Sales -> Select a sale -> Delete',
    createProduct: 'Create your products',
    createProductDescription: 'To do this, go to the Main Menu -> Products, Services, and Ingredients -> Press the plus sign in the top right corner. Fill in the fields and press save. You can read the instructions for creating and descriptions of the fields by the link at the top of the window.',
    createSupply: 'Create a supply',
    createSupplyDescription: 'After creating a product, you can make its supply. Supply will increase the quantity of the product in Product Stocks. To create a supply, go to the Main Menu -> Supplies and press the plus sign in the top right corner. Fill in the fields and press save. You can read the instructions for creating and descriptions of the fields by the link at the top of the window.',
    createSpending: 'Add an expense',
    createSpendingDescription: 'In ATLAS, in addition to sales and product stocks, you can manage your expenses. You can either add monthly expenses in Settings -> Monthly Expenses. Or create one-time expenses through the Main Menu -> Expenses -> Plus sign in the top right corner.',
    profitReport: 'View Profit Report',
    profitReportDescription: 'The main report for which we keep records in business. All your data entered into the application are aggregated here. All your incomes, expenses for the period are calculated, and your profit is automatically calculated.',
    viewModules: 'Explore all available ATLAS modules',
    viewModulesDescription: 'In addition to the modules that you see on the main page, there are others, but they are currently turned off. To view all modules and enable them, go to the Main Menu -> Organization Settings -> Enable modules and press save.',
    viewHelp: 'View the help center',
    viewHelpDescription: 'If you still have questions, you can explore the Help Center or contact support. For this, below this checklist, there are special buttons.',
    viewWeb: 'Go to the web version for computers',
    viewWebDescription: 'ATLAS is also available from a computer through any browser at atlas-app.org. You can work simultaneously from any devices, everything will be synchronized in real-time. In the browser version, you can additionally connect a barcode scanner and receipt printers.',
    clickOnQuestionToGetStarted: 'Click on the question mark to get started',
  },
  welcome: {
    header1: 'Super app for your business',
    text1: 'Sales, product stocks, expenses, salaries, loyalty program... Keep track of all aspects of your business in one convenient app.',
    header2: 'Suitable for any business',
    text2: 'Stores, coffee shops, bakeries, Instagram sales, manufacturing... Whether you sell goods or provide services, work with individuals or b2b - customize the app for yourself.',
    header3: 'Accessible from any device',
    text3: 'Web and mobile applications - use on a computer, phone, iPad, and any tablet.',
    header4: 'Analyze data',
    text4: 'View reports in one place, the app automatically calculates all data and generates convenient reports.',
    header5: 'Work as a team',
    text5: 'Invite your team and stay informed about everything happening in your business. Real-time data updates on each device. Flexible role system.',
  },
  organizationDetails: {
    salesText: 'Simple sales',
    complexSalesText: 'Complex sales',
    spendingsText: 'Expenses',
    shiftText: 'Shift',
    stockText: 'Product stocks',
    suppliesText: 'Receptions',
    writeOffsText: 'Write-offs',
    revisionsText: 'Revisions',
    transfersText: 'Transfers',
    salaryText: 'Salary',
    checklistText: 'Checklist',
    ecommerceText: 'Online catalog and orders',
    updatesText: 'Updates',
    paymentsText: 'Payments',
    printStickersText: 'Print labels',
    manufacturesText: 'Manufacturing',
    clientsText: 'Clients and loyalty program',
    salesLink: 'https://atlas-app.notion.site/94b264a6d378489dad3ef681d679af82',
    complexSalesLink: 'https://atlas-app.notion.site/2fa413068a3c4cd29b4646b437cdbf5f',
    spendingsLink: 'https://atlas-app.notion.site/577d6dbf02aa4c4ab51a48b029bf0038',
    shiftLink: 'https://atlas-app.notion.site/fb5bb12a8edb4210b1712d9eb103515b',
    stockLink: 'https://atlas-app.notion.site/15479a3a4c5941ea81283658a1a7183d',
    suppliesLink: 'https://atlas-app.notion.site/9956e87ae47b404c85a995d8f4f09456',
    writeOffsLink: 'https://atlas-app.notion.site/8d3afa9a60944231a7061ea4add436a4',
    revisionsLink: 'https://atlas-app.notion.site/7cf86210f8054035ae8906a63a135d41',
    transfersLink: 'https://atlas-app.notion.site/fe86dd9a659b46e389baadeb304550f9',
    salaryLink: 'https://atlas-app.notion.site/9a89871ffe844ef385adecd8e9898322',
    checklistLink: 'https://atlas-app.notion.site/e600dd8d172f4955a3462cab61ad8bb5',
    ecommerceLink: 'https://atlas-app.notion.site/37c3ac79d75847b99fe2aed713701924',
    updatesLink: 'https://atlas-app.notion.site/c5f1807c38504e51b036dd06268eb8fc',
    paymentsLink: 'https://atlas-app.notion.site/c49dc592f2304232831e48a2f401e676',
    printStickersLink: 'https://atlas-app.notion.site/4444f23cc8b34917b4637e7ebc7416fa',
    manufacturesLink: 'https://atlas-app.notion.site/b543d903c7404428809ce7e8d3c06898',
    clientsLink: 'https://atlas-app.notion.site/5c89d17429434438a5455a21f229e7d4',
    salesDescription: 'In Sales, you can make simple sales and view sales history. Suitable for stores, catering, distributors, standard services, and simple manufacturing',
    complexSalesDescription: 'In Complex Sales, you can manage sales consisting of several products, services, expenses with the possibility of manually setting the sale amount. Also implemented is the functionality of statuses and calculation of sales profitability. Suitable for those who sell custom services and manufacturing.',
    spendingsDescription: 'In Expenses, you can keep track of your expenses.',
    shiftDescription: 'Shifts are needed for convenience of working with cash in the cash register and for controlling shift employees. With them, it is convenient to understand whether there were cash shortages for this shift.',
    stockDescription: 'In Product Stocks, you can view the actual quantity of goods in stock if you keep track of product stocks.',
    suppliesDescription: 'In Receptions, you can keep track of receptions/deliveries of goods or ingredients from your suppliers. What in what quantity you received from whom and when.',
    writeOffsDescription: 'In Write-offs, you can keep track of written-off goods or ingredients. For example, if they spoiled or came in unsaleable condition or you just gave them to someone.',
    revisionsDescription: 'In Revisions, you can keep track of inventory audits - this is when you recount the actual quantity of goods and compare it with the amount that should be according to the system.',
    transfersDescription: 'In Transfers, you can record the movement of goods from one branch/warehouse to another.',
    salaryDescription: 'In Salary, you can keep track of shift employees working time and automatically calculate their salary depending on the worked time.',
    checklistDescription: 'Checklists are a list of tasks for your employees for each day, where they can mark what and when they did.',
    ecommerceDescription: 'You can create an online catalog in one click and receive orders from there. After enabling, you need to additionally configure in Settings -> Marketplace Settings.',
    updatesDescription: 'In Updates, updates on the organization are collected - price changes, deleted sales - so that everyone is in the know.',
    paymentsDescription: 'In Payments, you can keep track of payments to suppliers, salary payments to employees, payments for monthly expenses. And view a very useful report on cash flow at the end',
    printStickersDescription: 'In Print Labels, you can print labels with barcodes. Available only in the browser version on a computer.',
    manufacturesDescription: 'In Manufacturing, you can keep track of manufactured goods - if, for example, you bake pastries or embroider clothes from different ingredients/materials',
    clientsDescription: 'In Clients, you can keep track of clients, indicate them in sales, and connect a loyalty program. After enabling, you need to additionally configure the loyalty program in Settings -> Loyalty Program Settings.',
    nanErrorText: 'The number of decimal places must be a number',
    decimalPlacesErrorText: 'The number of decimal places must be from 0 to 5',
    name: 'Name',
    currency: 'Currency',
    currencyDecimalPlaces: 'Number of decimal places in prices',
    enabledModules: 'Used modules',
    moreInfo: ' More info',
    deleteOrg: 'Delete organization and account',
    deleteOrgConfirmationText: 'Please confirm the deletion of your account and organization with ATLAS. All your data will be deleted without the possibility of recovery.',
    email: 'Email',
    password: 'Password',
    delete: 'Delete',
    resetStocks: 'Reset stocks',
    resetData: 'Reset Data',
    resetDataDescription: 'Select which data to reset and specify the date range. This action cannot be undone.',
    resetSelectedData: 'Reset Selected Data',
    confirmResetData: 'Confirm Data Reset',
    confirmResetDataDescription: 'You are about to reset the following data. This action cannot be undone.',
    confirmReset: 'Confirm Reset',

    // Reset operations descriptions
    salesResetDescription: 'Reset all sales data including simple sales and sales history.',
    complexSalesResetDescription: 'Reset all complex sales data including custom services and manufacturing sales.',
    suppliesResetDescription: 'Reset all incoming supplies and deliveries data.',
    writeOffsResetDescription: 'Reset all write-offs data including spoiled or damaged goods.',
    transfersResetDescription: 'Reset all transfers between stores/warehouses.',
    spendingsResetDescription: 'Reset all expenses and spending records.',
    revisionsResetDescription: 'Reset all inventory revision data.',
    manufacturesResetDescription: 'Reset all manufacturing records.',
    productStockResetDescription: 'Reset all product stock quantities to zero and delete movement history.',
    resetDataBeforeDate: 'Reset data before date',
    warning: 'Warning',
    resetDataWarning: 'This action will permanently delete all data before the selected date (data from the selected date itself will not be deleted). This action cannot be undone',
    whatWillBeDeleted: 'What will be deleted:',
    beforeDate: 'before',
    dailyStats: 'Daily Statistics',
    monthlyStats: 'Monthly Statistics',
    dailyProductReports: 'Daily Product Reports',
    transactions: 'Transactions',
    productStockSnapshots: 'Product Stock Snapshots',
    orders: 'Orders',
    movementData: 'Product Movement Data',
    allProductStocks: 'All Product Stocks (reset to zero)',
    allProducts: 'All Products (delete completely)',
    resetAllData: 'Reset All Data',
    additionalOptions: 'Additional Options',
    resetProductStocks: 'Reset Product Stocks',
    resetProductStocksDescription: 'Reset all product stock quantities to zero',
    deleteAllProducts: 'Delete All Products',
    deleteAllProductsDescription: 'Permanently delete all products from the organization',
    adminRequired: 'Admin Access Required',
    adminRequiredDescription: 'Only administrators can perform data reset operations. Please contact your administrator if you need to reset data.',
    adminRequiredError: 'Only administrators can perform data reset operations.',
  },
  productsAndIngredients: {
    productsAndIngredients: 'Products, services, and ingredients',
    new: 'New',
    barcodeAlreadyUsed: 'Barcode is already used in product - ',
    copy: 'Copy + ',
    copyMadeToast: 'Copy created, edit fields and save',
    makeACopy: 'Create a copy',
    instructions: 'Filling instructions',
    general: 'General',
    name: 'Name',
    namePlaceholder: 'Milk 1l',
    status: 'Status',
    enabled: 'Enabled',
    forItem: ' for {{item}}',
    productType: 'Product type',
    product: 'Product',
    service: 'Service',
    priceTypes: 'Price Types',
    advancedPricing: 'Advanced Pricing',
    noPriceTypesConfigured: 'No price types configured. Please configure price types in settings.',
    price: 'Price',
    copyFromFirst: 'Copy from first',
    priceTypesHint: 'Configure price types in Settings to add more pricing options.',
    autoCalculated: 'Calculated automatically',
    hideInNewSaleScreen: 'Hide on New Sale screen (for ingredients)',
    hideInNewSaleScreenShort: 'Hide in New Sale',
    additionalPrices: 'Additional Prices',
    additionalPricesHint: 'Optional additional pricing (wholesale, BNPL, etc.). Default price is set above in Sale Price field.',
    configureInSettings: 'Configure additional price types in Settings → Price Types',
    organizationWide: 'Common price organization-wide',
    perStore: 'Separate prices per store',
    composite: 'Composite',
    manufactureType: 'Manufacture type',
    manufacturedBeforeSale: 'Product needs to be manufactured in advance (example - bread, you will be able to track the inventory of manufactured goods)',
    manufacturedDuringSale: 'Product is manufactured during the sale (example - cappuccino, the inventory quantity of the manufactured product will always be 0)',
    purchasePrice: 'Purchase price',
    additionalSpendingsToPurchasePrice: 'Additional expenses to the purchase price (expenses for the label, packaging)',
    additionalSpendingsToPurchasePriceShort: 'Additional expenses',
    salePrice: 'Sale price',
    category: 'Category',
    supplier: 'Supplier',
    productUnit: 'Unit of measurement',
    productUnits: 'Units of measurement',
    barcode: 'Barcode',
    addAdditionalBarcode: 'Add another barcode',
    forProductStocks: 'For Product Stocks',
    inStockQuantity: 'Quantity of product in stock',
    showStocksinFloat: 'Show stocks in fractional numbers',
    floatNumbers: 'Fractional numbers',
    showInImportantProducts: 'Show in important products',
    show: 'Show',
    quantityToHighlightRed: 'Quantity at which to highlight in red',
    forLoyaltyProgram: 'For loyalty program',
    punchCardParticipation: 'Participates in the program "N-th drink for free"',
    participates: 'Participates',
    forEcommerce: 'For online store',
    activeInEcommerce: 'Available in online store',
    oldPrice: 'Old price (for promotion)',
    tags: 'Tags',
    defaultQuantity: 'Default weight',
    photos: 'Photos',
    takePhoto: 'Take photo',
    chooseFromGallery: 'Choose from gallery',
    showDisabledProducts: 'Show disabled products',
    nameEmptyError: 'Please fill in the name field',
    categoryEmptyError: 'Please fill in the category field',
    supplierEmptyError: 'Please fill in the supplier field',
    productUnitEmptyError: 'Please fill in the product unit field',
    imageStillUploadingError: 'Please wait till image has completed uploading',
    salePricesEmptyError: 'Please fill in the sale price field',
    purchasePriceEmptyError: 'Please fill in the purchase price field',
    compositeNoIngredientsError: 'Composite products must have at least one ingredient',
    productUsedAsIngredientError: 'Cannot delete a product used as an ingredient in another product. First remove them as ingredients in other products: {{products}}.',
    usedAsIngredient: 'Used as ingredient in:',
    editedItems: "Edited {{count}} items",
    visibleFields: "Enabled fields",
    filters: "Filters",
    batchEdit: 'Batch Edit',
    exportImport: 'Export/Import',
  }, 
  home: {
    salesForToday: 'Sales\nfor today',
    numberOfChecks: 'Number\nof receipts',
    averageCheck: 'Average\nreceipt',
    upgradePromptText: 'Upgrade to a paid plan to get more limits.',
    upgrade: 'Upgrade',
  },
  billing: {
    id: 'ID',
    plan: 'Plan',
    price: 'Price',
    status: 'Status',
    subscriptions: 'Subscriptions',
    past_due: 'Payment overdue',
    paused: 'Paused',
    deleted: 'Cancelled',
    deletedPaymentFailed: 'Not renewed — payment failed',
    active: 'Active',
    undefined: 'Free',
    purchaseDate: 'Purchase date',
    paidTill: 'Paid until',
    restorePurchases: 'Restore purchases from App Store',
    billingSuccessReload: 'Payment was successful. Please reload the page, your plan will update within a minute',
    continueOnWeb: 'Please continue on the web version of ATLAS to manage this subscription (https://atlas-app.org)',
    continueOnIos: 'Please continue on the iOS version of ATLAS to cancel this subscription',
    organizationName: 'Organization: {{orgName}}',
    currentPlan: 'Current plan: {{currentPlan}}', 
    planStatus: 'Plan status: {{planStatus}}',
    monthlySalesUSD: 'Monthly sales: ~${{monthlySalesUSD}}',
    webHintRussia: 'There are payment issues for Russian cardholders. An alternative payment method is described at the link.',
    iosHintRussia: 'Payment instructions for the Russia region in the App Store are described at the link.',
    androidBillingDisabled: 'Android billing is disabled. Please use the Atlas Web version to manage your subscription (https://atlas-app.org)',
    manageSubscription: 'Manage subscription',
    cancelSubscription: 'Cancel subscription',
    updatePaymentMethod: 'Update payment method',
    changePlan: 'Change plan',
    perMonth: '/month',
    buy: 'Buy',
    noPurchases: 'No purchases found',
    sourceRevenuecat: 'Purchased on App Store',
    sourcePaddle: 'Purchased on Web',
    subscriptionManagedByRevenuecatError: 'Subscription managed by App Store. Please use the iOS app to manage this subscription',
    cancelSurveyTitle: 'Why are you canceling?',
    cancelSurveyText: 'We\'d love to know why you\'re leaving to help us improve our service.',
    selectReason: 'Select a reason',
    confirmCancel: 'Confirm Cancellation',
    selectCancelReason: 'Please select a reason for cancellation',
    cancelReasonTooExpensive: 'Too expensive',
    cancelReasonMissingFeatures: 'Missing features I need',
    cancelReasonNotUsing: 'Not using the service enough',
    cancelReasonBugs: 'Too many bugs/issues',
    cancelReasonOther: 'Other reason',
    cancelReasonFoundBetter: 'Found a better alternative',
    cancelReasonBusinessClosing: 'Business is closing/closed',
    cancelReasonOtherPlan: 'Switching to another plan',
  },
  pricingPlans: {
    freeName: 'Free',
    freeDescription: 'Only for beginner entrepreneurs - your sales are less than $1000 per month',
    tier1Name: 'Plan 1',
    tier1Description:  'Your sales are from $1,000 to $10,000 per month',
    tier2Name: 'Plan 2',
    tier2Description: 'Your sales are from $10,000 to $20,000 per month',
    tier3Name: 'Plan 3',
    tier3Description: 'Your sales are from $20,000 to $50,000 per month',
  },
  paywall: {
    title: 'ATLAS Business',
    subtitle: 'The most convenient accounting system for 1000+ small businesses all over the world',
    cta: 'Continue',
    popular: 'MOST POPULAR',
    seeOtherPlans: 'See other plans',
    perMonthAfterTrial: '/month after a 14-day trial period',
    salesMonthly: ' sales per month',
    users: ' user(s)',
    branches: ' branch(es)',
    modules: 'Modules',
    support: 'Support',
  },
  reviews: {
    reviewName1: 'Cosmetics shop',
    reviewText1: 'Excellent application, I will recommend it to others',
    reviewName2: 'Coffee-to-go',
    reviewText2: 'Thank you so much for such a wonderful program, very helpful for our business',
    reviewName3: 'Coffee distributor',
    reviewText3: 'My employees tried 5 different apps and they said that yours is the most convenient',
    reviewName4: 'Bike Service',
    reviewText4: 'Great! I think for small organizations that provide services - it will be a super useful application',
    reviewName5: 'Furniture manufacturing',
    reviewText5: 'Everything is clear and accessible. Thank you for the useful program. The Complex sales feature is the best for us.',
  },
  funnel: {
    continue: 'Continue',
    chooseYourPrimaryGoal: 'What is your primary goal?',
    increaseSales: 'Increase sales',
    reduceCosts: 'Reduce costs',
    improveOperations: 'Improve operations',
    choseAtlas: '1000+',
    choseAtlasDescription: 'small businesses all over the world use ATLAS to manage their business',
    chooseYourBusinessType: 'What is your business type?',
    retail: 'Shops / boutiques / retail outlets',
    restaurant: 'Cafes / restaurants / coffee shops / takeaway',
    online: 'Online trade',
    manufacture: 'Manufacturing / workshops',
    suppliers: 'Distributors / suppliers',
    services: 'Services',
    construction: 'Construction',
    other: 'Other',
    chooseYourClientType: 'What is your client type?',
    b2c: 'Only individuals (b2c)',
    b2b: 'Only companies (b2b)',
    'b2b>b2c': 'Both individuals and companies, but more companies',
    'b2c>b2b': 'Both individuals and companies, but more individuals',
    'b2c&b2b': 'Both individuals and companies',
    chooseYourCurrency: 'What currency do you use?',
    '0': 'No employees',
    '1-5': '1-5',
    '5-20': '5-20',
    '20-50': '20-50',
    '50+': 'More than 50',
    doYouHaveBranches: 'Do you have branches?',
    'no': 'No',
    'yes': 'Yes',
    branchCount: 'How many branches do you have?',
    employeeCount: 'How many employees do you have?',
    chooseAdditionalFeatures: 'What additional features are you interested in?',
    yourPriorExeperience: 'How did you manage your business before?',
    setupOptions: 'Do you need help with setup?',
    trafficSource: 'Where did you hear about us?',  
    orgName: 'What is your business name?',
    userName: 'What is your name?',
    userPhone: 'What is your phone number?',
    userEmail: 'What is your email?',
    userPassword: 'Set a password',
    creatingOrg: 'Thank you for your answers! We are customizing your organization',
    profitabilityTitle: 'Did you know?',
    profitabilityDescription: 'Businesses that properly track their finances and inventory are 3x more likely to be successful. Atlas helps you manage both with ease.',
    clientTrackingTitle: 'Do you want to track your clients?',
    clientTrackingDescription: 'Atlas helps you track clients and reward their loyalty',
    loyaltyProgramTitle: 'Do you want to enable a loyalty program?',
    loyaltyProgramDescription: 'Choose which loyalty program you\'d like to use:',
    loyaltyTypeNone: 'Not now - I\'ll set it up later',
    loyaltyTypeCashback: 'Cashback Program - Give % back as bonuses from each purchase',
    loyaltyTypePunchCard: 'Punch Cards - Give every N-th product for free (great for coffee shops!)',
    cashbackLevelTitle: 'Choose default cashback percentage',
    cashbackLevelDescription: 'What % of purchase amount should clients receive as bonuses?',
    bonusLevel: '{{percent}}% from each purchase',
    punchCardCapacityTitle: 'Choose punch card capacity',
    punchCardCapacityDescription: 'How many purchases should a client make to get a free product? Only products that you add to the loyalty program will be included',
    punchCardCapacity: 'Every {{count}}th product free',
    onlineCatalogTitle: 'Want to create an online catalog?',
    onlineCatalogDescription: 'Atlas can automatically create an online catalog of your products that you can share with clients',

    salesTrackingTitle: 'Do you track your sales now?',
    salesTrackingDescription: 'Atlas will help you track sales and create actionable reports',
    salesTrackingNo: 'Don\'t track sales at all',
    salesTrackingDetailTitle: 'What exactly do you track?',
    salesTrackingDetailDescription: 'Select all that apply:',

    salesReportsTitle: 'What reports are you interested in?',
    salesReportsDescription: 'Select all that apply:',
    salesReportsOverall: 'Sales by days and weeks',
    salesReportsByProduct: 'Best-selling products',
    salesReportsByEmployee: 'Sales by employees',
    salesReportsWithProfit: 'Monthly profit and losses',
    salesReportsSpendings: 'Operating expenses report',
    
    // Monthly Sales Volume
    monthlySalesVolume: 'What is your approximate monthly sales volume?',
    salesVolumeLess1k: 'Less than $1,000',
    salesVolumeFrom1kTo10k: '$1,000 - $10,000',
    salesVolumeFrom10kTo20k: '$10,000 - $20,000',
    salesVolumeFrom20kTo50k: '$20,000 - $50,000',
    salesVolumeMore50k: 'More than $50,000',
    
    // Inventory Size
    inventorySize: 'How many different products/services do you offer?',
    inventoryLess50: 'Less than 50',
    inventory50to200: '50 - 200',
    inventory200to1000: '200 - 1,000',
    inventoryMore1000: 'More than 1,000',
    
    // Inventory Management Questions
    inventoryManagementTitle: 'Tell us about your inventory management needs',
    inventoryTrackingQuestion: 'How do you want to track your inventory?',
    inventoryTrackingNone: 'No need to track inventory',
    inventoryTrackingBasic: 'Basic tracking (quantities only)',
    inventoryTrackingAdvanced: 'Advanced tracking (with negative stock prevention, alerts and multiple stocks)',

    inventoryOperationsQuestion: 'What inventory operations do you need?',
    inventoryOperationsSupplies: 'Track supplies/purchases',
    inventoryOperationsWriteOffs: 'Track write-offs/wastage',
    inventoryOperationsTransfers: 'Transfer between locations',
    inventoryOperationsRevisions: 'Regular inventory counts/revisions',
    inventoryOperationsManufacture: 'Product manufacturing/assembly',
    
    barcodeQuestion: 'Do you use barcodes?',
    barcodeNo: 'No barcodes',
    barcodeYesOwn: 'Yes, we have our own barcodes',
    barcodeYesSupplier: 'Yes, we use supplier barcodes',
    barcodeWantToStart: 'Want to start using barcodes',
    analysisTitle: 'Analyzing your answers...',
    analysisDescription: 'We are personalizing Atlas to match your business needs',
    reviewName1: 'Coffee Shop Owner',
    reviewText1: 'Atlas helped us increase our revenue by 23% in just 3 months by better tracking inventory and reducing waste',
    reviewName2: 'Boutique Manager',
    reviewText2: 'The loyalty program is amazing! Our customers love it and keep coming back',
    reviewName3: 'Restaurant Chain',
    reviewText3: 'Managing multiple locations became so much easier. The reports help us make better decisions',
    reviewName4: 'Online Store',
    reviewText4: 'The online catalog feature saved us so much time. Our customers can now browse products easily',
    reviewName5: 'Small Retail Shop',
    reviewText5: 'Perfect for small businesses. Easy to use and has everything we need',
  },
  exportImport: {
    exportImport: 'Export/Import',
    ignore: 'Ignore/Skip',
    name: 'Name',
    price: 'Price',
    purchasePrice: 'Purchase price',
    barcode: 'Barcode',
    category: 'Category',
    supplier: 'Supplier',
    inStock: 'In stock',
    externalId: 'ID',
    clientExport: 'Client Export',
    downloadClientExport: 'Download client export',
    generateClientExport: 'Generate client export',
    productExport: 'Product export',
    generateProductExportCSV: 'Export products to CSV',
    generateProductExportExcel: 'Export products to Excel',
    importProducts: 'Import products',
    other: 'Other',
    pcs: 'pcs',
    yes: 'yes',
    uploadProducts: 'Upload products',
    previewImport: 'Preview of imported data',
    mapColumns: 'Map product fields to imported columns',
    import: 'Import',
    column: 'Column',
    selectField: 'Select field',
    confirmImport: 'Confirm Import',
    dropFileHere: 'Drop CSV file here',
    releaseToUpload: 'Release to upload',
    dragAndDropHint: 'Drag & drop a CSV file here, or click to select one',
    next: 'Next',
    mapCategories: 'Map imported categories to existing in ATLAS',
    mapSuppliers: 'Map imported suppliers to existing in ATLAS',
    createNewCategory: 'Create new category',
    createNewSupplier: 'Create new supplier',
    updateExistingProductsSettings: 'Update existing products settings',
    updateExistingProductsSettingsHint: 'If there are products with the same ID or barcode in ATLAS - should they be updated with the data from the imported file?',
    requiredColumnsMissing: 'Name, purchase price, and price columns are required',
    update: 'Update',
    doNotUpdate: 'Do not update',
    totalRows: 'Total rows: {{count}}',
    importDone: 'Import done!',
    importProgress: 'Import progress: ({{count}} of {{totalCount}})',
    importError: 'Import error: {{error}}',
    importStore: 'Store for prices and stock',
    importStoreHint: 'Price and stock from the file change only in this store. A stock change of an existing product is saved as a revision.',
    importNotStarted: 'Import not started: fix the rows of the file and upload it again. Nothing was changed.',
    importRowError_invalidNumber: 'Row {{row}}: "{{column}}" is not a number: {{value}}',
    importRowError_idNotFound: 'Row {{row}}: no product with ID {{value}}',
    importRowError_duplicateProduct: 'Row {{row}}: this product is already in row {{firstRow}}',
    importRowError_duplicateBarcode: 'Row {{row}}: barcode {{value}} is already in row {{firstRow}}',
    importRevisionFailed: 'Import not started: the stock revision could not be saved ({{error}}). No product was changed.',
    importStopped: 'Import stopped at row {{row}}: {{error}}',
    importRowsWritten: 'Rows written: {{rows}}',
    importRowsNotWritten: 'Rows not written: {{rows}}',
    importSummary: 'Products updated: {{updated}}, created: {{created}}, stock changed: {{stockChanged}}',
    importRevisionSaved: 'Stock changes ({{count}}) saved as a revision',
    importSkippedExisting: 'Existing products were not updated ("Do not update" chosen), rows: {{rows}}',
    importProductsHint: 'You can import products from a CSV file. The file must contain the following columns: name, price, purchase price, barcode, category, supplier, stock. The first row of the file must contain the column names.',
    exportProductsHint: 'You can export products to a CSV/Excel file. The file will contain the following columns: name, price, purchase price, barcode, category, supplier, stock. The first row of the file will contain the column names.',
    exportClientsHint: 'Export all client data to CSV or Excel format',
    generateClientExportCSV: 'Export Clients to CSV',
    generateClientExportExcel: 'Export Clients to Excel',
    phone: 'Phone',
    totalPurchasedValue: 'Total purchased value',
    registrationDate: 'Registration date',
    lastPurchaseDate: 'Last purchase date',
    bonusValue: 'Bonus value',
  },
  salesImport: {
    title: 'Sales import',
    openImporter: 'Go to sales import',
    hint: 'Import sales from an .xlsx, .csv or .tsv file. One row per sold item: article, quantity, client (phone) and date. Rows with the same client and date can be joined into a single order. Imported sales reduce stock and appear in reports exactly like ordinary sales, so a summary is shown before anything is written.',
    article: 'Article',
    quantity: 'Quantity',
    date: 'Date',
    client: 'Client (phone)',
    paymentMethod: 'Payment method',
    ignore: 'Skip/Do not import',
    uploadSales: 'Upload sales file',
    dropFileHere: 'Drop the file here',
    dragAndDropHint: 'Drag and drop an .xlsx, .csv or .tsv file here, or click to choose one',
    readError: 'Could not read the file: {{error}}',
    unsupportedFile: 'Unsupported file. Please choose an .xlsx, .xls, .csv or .tsv file',
    emptyFile: 'The file has no data: a header row and at least one sale row are required',
    previewImport: 'File preview',
    totalRows: 'Total rows: {{count}}',
    mapColumns: 'Map the columns',
    selectField: 'Select a column',
    requiredColumnsMissing: 'Required columns are not mapped: {{columns}}',
    next: 'Next',
    store: 'Store',
    storeRequired: 'Choose a store',
    grouping: 'Row grouping',
    groupingHint: 'When on, rows with the same client and date become one order. Rows without a client are never joined — each becomes its own sale.',
    joinByClientAndDate: 'Join client + date into one order',
    defaultPaymentMethod: 'Default payment method',
    defaultPaymentMethodHint: 'Used for rows with no payment column or an unrecognised value. "On credit" records the sale unpaid: no money reaches any wallet.',
    selectPaymentMethod: 'Select a payment method',
    paymentMethodRequired: 'Select a default payment method',
    postPaid: 'On credit (unpaid)',
    mapClients: 'Clients',
    mapClientsHint: 'Clients are matched by phone number. For the ones not found, choose whether to create a new client or import the sale without a client.',
    searchingClients: 'Looking up clients by phone number...',
    clientFound: 'Found: {{name}}',
    clientLookupFailed: 'Lookup failed — choose an option manually',
    createClient: 'Create client',
    withoutClient: 'Without a client',
    summary: 'Check before importing',
    summaryOrders: 'Orders to create: {{count}}',
    summaryRows: 'Item rows: {{count}}',
    summaryClients: 'Orders with a client: {{count}}',
    ordersPreview: 'What will be created',
    summaryTotal: 'Sales total: {{total}}',
    negativeStockWarning: 'Stock would go negative after the import:',
    negativeStockRow: '{{name}}: in stock {{inStock}}, selling {{quantity}} → {{resulting}}',
    invalidRows: 'Rows with errors: {{count}}',
    invalidRow: 'Row {{row}}: {{reason}}',
    invalidRowWithValue: 'Row {{row}}: {{reason}} — "{{value}}"',
    andMore: '...and {{count}} more',
skipInvalidRows: 'Skip the rows with errors and import the rest',
    downloadIssues: 'Download the error report',
    import: 'Import {{count}} orders',
    importProgress: 'Importing {{count}} of {{totalCount}}...',
    importError: 'Import error: {{error}}',
    done: 'Import finished',
    doneOrders: 'Orders created: {{count}}',
    doneRows: 'Rows imported: {{count}}',
    failedOrders: 'Orders that failed: {{count}}',
    failedOrder: 'Rows {{rows}}: {{reason}}',
    importAnotherFile: 'Import another file',
    reportRow: 'Row',
    reportStatus: 'Status',
    reportReason: 'Reason',
    reportValue: 'Value',
    reportSkipped: 'Skipped',
    reportFailed: 'Failed during import',
    error: {
      MISSING_ARTICLE: 'No article given',
      MISSING_QUANTITY: 'No quantity given',
      INVALID_QUANTITY: 'Quantity must be a number greater than zero',
      MISSING_DATE: 'No date given',
      INVALID_DATE: 'Could not read the date — expected 31.12.2026 or 2026-12-31',
      PRODUCT_NOT_FOUND: 'No product matches this article',
    },
  },
  manufactureImport: {
    title: 'Manufacture import',
    openImporter: 'Go to manufacture import',
    hint: 'Import manufactures from one or more .xlsx, .csv or .tsv files. One row is either one manufacture using the product\'s recipe (date, product, quantity, batch) or one ingredient line: rows with the same "Production no." in one file are one manufacture, and their ingredients replace the recipe. An imported manufacture changes stock and appears in reports exactly like one entered by hand, so a summary is shown before anything is written.',
    uploadFiles: 'Upload manufacture files',
    addMoreFiles: 'Add more files',
    dropFilesHere: 'Drop the files here',
    dragAndDropHint: 'Drag one or more .xlsx, .csv or .tsv files here, or click to choose',
    unsupportedFile: 'Unsupported file. Use .xlsx, .xls, .csv or .tsv',
    readingFiles: 'Reading files...',
    filesTitle: 'Files ({{count}})',
    fileRows: 'data rows: {{count}}',
    fileUnreadable: 'could not be read: {{error}}',
    clearFiles: 'Remove all files',
    noReadableFile: 'None of the files could be read — there is nothing to map',
    next: 'Next',
    back: 'Back',
    mapColumns: 'Map the columns',
    mapColumnsHint: 'Columns are chosen from the first file ({{file}}) and applied to every file by header name. A file without a chosen column is skipped as a whole and listed in the report.',
    selectColumn: 'Choose a column',
    ignore: 'Do not import',
    options: 'Import options',
    store: 'Store',
    includeDuplicates: 'Import probable duplicates',
    includeDuplicatesHint: 'A probable duplicate is a manufacture that already exists in Atlas: same product, same store business day and same quantity, and batch numbers that do not contradict: equal, or missing on either side. They are skipped by default so that importing a file twice does not double the stock.',
    loadingExisting: 'Checking existing manufactures and revisions...',
    loadError: 'Could not load existing manufactures or revisions: {{error}}',
    summary: 'Check before importing',
    summaryFiles: 'Files accepted: {{accepted}}, rejected: {{rejected}}',
    summaryPrepared: 'Manufactures in the files: {{count}}',
    summaryToImport: 'Manufactures to create: {{count}}',
    summarySkippedDuplicates: 'Probable duplicates to skip: {{count}}',
    summaryDuplicates: 'Probable duplicates: {{count}}',
    summaryTwins: 'Identical manufactures within the files: {{count}} (all will be created)',
    summaryTotalCost: 'Cost of the manufactures to create: {{total}}',
    lastHandEntered: 'Last manufacture entered by hand in this store: {{date}}',
    lastHandEnteredNone: 'No manufacture entered by hand in this store since {{date}}',
    lastRevision: 'Last stock revision in this store: {{date}}',
    lastRevisionNone: 'No stock revision in this store since {{date}}',
    revisionWarning: 'Manufactures that may predate the last revision: {{count}} — timed before it or, when the file gives no time, on the revision\'s business day or earlier. That revision may already have counted them in stock — importing them changes stock again. Decide whether to import them, remove them from the file, or count stock again after the import.',
    costPriceNote: 'Cost is calculated at the ingredients\' current purchase prices, as for a manufacture entered by hand.',
    manufacturesPreview: 'What will be created',
    rowQuantity: 'qty {{quantity}}',
    rowBatch: 'batch {{batch}}',
    rowIngredients: 'ingredients: {{count}}',
    rowCost: 'cost {{total}}',
    badge: {
      duplicate: 'probable duplicate',
      twin: 'identical manufacture in the files',
      beforeRevision: 'may predate the last revision',
      skipped: 'will be skipped',
    },
    invalidRows: 'Errors: {{count}} — these rows and files will not be imported',
    andMore: '...and {{count}} more',
    downloadReport: 'Download report',
    import: 'Import {{count}} manufactures',
    importProgress: 'Importing {{count}} of {{totalCount}}...',
    importError: 'Import error: {{error}}',
    done: 'Import finished',
    doneCreated: 'Manufactures created: {{count}}',
    doneSkipped: 'Probable duplicates skipped: {{count}}',
    doneFailed: 'Could not be created: {{count}}',
    doneErrors: 'Not imported because of errors in the files: {{count}}',
    importMore: 'Import other files',
    failure: {
      INGREDIENT_NOT_FOUND: 'Ingredient "{{ingredient}}" of product "{{product}}" is not in the catalog — the manufacture was not created',
    },
    report: {
      file: 'File',
      rows: 'Rows',
      product: 'Product',
      date: 'Date',
      quantity: 'Quantity',
      batch: 'Batch',
      status: 'Status',
      reason: 'Reason / note',
      statusRejected: 'Skipped (error)',
      statusSkippedDuplicate: 'Skipped (probable duplicate)',
      statusPlanned: 'Will be created',
      statusCreated: 'Created',
      statusFailed: 'Failed during import',
    },
    field: {
      date: 'Date',
      product: 'Product (article/barcode)',
      quantity: 'Quantity',
      batch: 'Batch',
      manufactureNo: 'Production no.',
      ingredient: 'Ingredient (article/barcode)',
      ingredientPerUnit: 'Per 1 unit',
    },
    mismatchField: {
      date: 'date',
      product: 'product',
      quantity: 'quantity',
      batch: 'batch',
      ingredient: 'the ingredient is given on some rows only',
    },
    error: {
      MISSING_DATE: 'Date is missing',
      INVALID_DATE: 'Could not read the date — expected 31.12.2026 or 2026-12-31',
      MISSING_PRODUCT: 'Product is missing',
      MISSING_QUANTITY: 'Quantity is missing',
      INVALID_QUANTITY: 'Quantity must be a number greater than zero',
      QUANTITY_NOT_STORABLE: 'Quantity: at most 4 decimal places and less than 1,000,000',
      BATCH_TOO_LONG: 'Batch number is longer than 100 characters',
      INGREDIENT_WITHOUT_NUMBER: 'Ingredient given without a "Production no."',
      MISSING_PER_UNIT: 'Ingredient amount per 1 unit is missing',
      INVALID_PER_UNIT: 'Amount per 1 unit must be a number greater than zero',
      PRODUCT_NOT_FOUND: 'Product not found',
      INGREDIENT_NOT_FOUND: 'Ingredient not found',
      AMBIGUOUS_PRODUCT: 'Several products match — use an article or barcode only one product has',
      AMBIGUOUS_INGREDIENT: 'Several ingredient products match — use an article or barcode only one product has',
      PRODUCT_NOT_COMPOSITE: 'Not a composite product — only a product with ingredients can be manufactured',
      EMPTY_RECIPE: 'The product\'s recipe is empty — add ingredients to the product or list them in the file',
      INVALID_RECIPE: 'An ingredient in the product\'s recipe has no quantity, or one that is not above zero — fix the product\'s recipe or list the ingredients in the file',
      GROUP_MISMATCH: 'Rows of one "Production no." disagree: {{fields}}',
      DUPLICATE_INGREDIENT: 'Ingredient repeated within one manufacture',
      FILE_UNREADABLE: 'The file could not be read',
      FILE_COLUMNS_MISSING: 'The file lacks the chosen columns — file skipped',
      FILE_EMPTY: 'The file has no data rows',
      FILE_DUPLICATE_NAME: 'A file with this name was already added — skipped (production numbers and report rows are tied to the file name)',
      MAPPING_REQUIRED_MISSING: 'No column chosen for "{{field}}"',
      MAPPING_INGREDIENT_INCOMPLETE: 'An ingredient column is chosen — "{{field}}" is needed too',
      MAPPING_COLUMN_REUSED: 'The column for "{{field}}" is already used by another field',
      STORE_REQUIRED: 'Choose a store',
    },
  },
  supplyOrders: {
    supplyOrders: 'Supply orders',
    supplyOrder: 'Supply order',
    showActive: 'Show active',
    completed: 'Completed',
    notCompleted: 'Not completed',
    status: 'Status',
    statusDraft: 'Draft',
    statusSent: 'Ordered',
    statusCancelled: 'Cancelled',
    statusCompleted: 'Completed',
    name: 'Name',
    currentQuantity: 'Current quantity',
    weeklySales: 'Weekly sales',
    weeklyWriteoffs: 'Weekly write-offs',
    orderQuantity: 'Order quantity',
    items: 'Items',
    totalPrice: 'Total price',
    totalSum: 'Total sum',
    threshold: 'Low stock threshold',
    exportPDF: 'Export to PDF',
    exportText: 'Copy as text',
    createSupply: 'Create supply',
    orderDate: 'Order date',
    dateUnreadable: 'The order date could not be read — saving is disabled so it is not overwritten',
    linesUnreadable: 'Some lines of this order could not be read — saving and export are disabled so they are not lost',
    noActiveOrders: 'No active orders',
    createNew: 'Create new order',
  },
  loyaltySettings: {
    cashbackName: 'Accumulative bonus system (Cashback)',
    enabled: 'Enabled',
    defaultBonusLevel: 'Starting cashback percentage for clients',
    punchCardName: 'N-th drink/product for free',
    punchCardCapacity: 'Which product will be free',
  },
  marketplaceSettings: {
    linkName: 'Online catalog via link',
    enabled: 'Enabled',
    providedLink: 'Your link to the online catalog - ',
    copy: 'Copy',
    marketplaceName: 'Available in the general ATLAS marketplace',
    description: 'Company and product description',
    storeForMarketplace: 'Which branch to take prices/availability of goods from',
    separateStoreForMarketplace: 'If you want to manage availability and prices of goods in the marketplace separately - create a new branch and specify it here',
    go: 'Go',
    stores: 'Branches',
    disableNotInStockProducts: 'Disable ordering of out-of-stock products',
    enabledCategories: 'Enabled product categories for marketplace',
    priceTypesForMarketplace: 'Available price types for marketplace',
  },
  stores: {
    singleStoreDeletionError: 'Cannot delete the only branch',
    activeUsersPresentInStoreError: 'Please first deactivate all users in this branch or transfer them to another branch: ',
    name: 'Name',
    address: 'Address',
    autoCloseShiftTime: 'Auto-close shift time',
    autoCloseShiftTimeHint: 'If you work after midnight, specify the time at which your working day ends.',
    timezone: 'Branch timezone',
    showStatsOnTop: 'Show statistics on the main page',
    show: 'Show',
    copySettingsFrom: 'Copy settings from another branch (enabled products, prices, payment methods, purchase methods)',
    ofd: 'Fiscalization OFD',
    lightKassaInfo: 'Light Kassa data',
    cashboxId: 'Cashbox ID',
    cashboxPin: 'Cashbox Pin',
    login: 'Login (phone number)',
    password: 'Password',
    wiponInfo: 'Wipon Kassa data',
    profile: 'Profile',
    cashbox: 'Cashbox',
    salePoint: 'Sale point',
    saleSection: 'Sale section',
    vatType: 'Consider VAT',
    withoutVat: 'Without VAT',
    vat12: 'VAT 12%',
    ofdnone: 'Without fiscalization',
    'ofdlight-kassa': 'Light Kassa',
    'ofdwipon-kassa': 'Wipon Kassa',
    wiponRefreshError: 'Could not refresh Wipon data. Check the login and password and try again. The current cashbox settings were not changed.',
    wiponRefreshUnavailable: 'Wipon did not return the list. Try again in a few minutes. The current cashbox settings were not changed.',
    wiponRefreshEmpty: 'Wipon returned no items for this profile. Check the profile in Wipon. The current cashbox settings were not changed.',
    wiponRefreshNoProfile: 'Select a profile first, then refresh. The current cashbox settings were not changed.',
    missingWalletConfigError: 'Cannot copy settings. Please configure wallets for the following payment methods in the source branch: {{methods}}',
    constantsNotLoadedError: 'Settings are still loading. Please wait a moment and try again.',
  },
  roles: {
    none: 'Without salary',
    hour: 'Hourly pay',
    day: 'Pay per day/shift',
    month: 'Monthly pay',
    individualSalesPercent: 'Percentage of individual sales',
    monthlyPlan: 'Monthly plan', 
    deleteAdminError: 'Cannot delete admin role. You can rename it.',
    deleteWithActiveUsersError: 'Please first deactivate all users with this role or change their role: ',
    addingWorkingHoursHint: 'Hourly and shift pay are accrued when adding an employee to a shift in the "Shift" and "Salary" sections. Monthly pay is accrued only in the "Salary" menu.',
    salaryType: 'Salary type',
    roleBonusType: 'Bonus type',
    withoutBonuses: 'Without bonuses',
    individualSalesPercentMinimumSalesHint: 'Choosing this option will calculate the employees bonus based on their individual sales. If you set a minimum amount, the percentage of sales will be accrued only if the sales for that day were above this amount. Accrued bonuses will be visible as employee salary in the "Salary" section and in the "Profit" report.',
    individualSalesPercentForBonuses: 'Percentage of individual sales for calculating employee bonuses',
    minIndividualSalesForDailySales: 'Minimum amount of daily sales for calculating employee bonuses',
    permissions: 'Permissions',
    chooseAll: 'Select all',
    clear: 'Clear',
    atLeastOneAdminError: 'There must be at least one active {{role}} in the organization',
    disableSuccess: 'User disabled, please reload the app in a minute',
    enableSuccess: 'User enabled, please reload the app in a minute',
    newEmployee: 'New employee',
    newUserError: 'Error',
    emailInvalidError: 'The email address is improperly formatted',
    emailAlreadyInUseError: 'The email address is already in use by another account',
    passwordWeakError: 'The password is too weak',
    onlyAdminCanChangeAdminError: 'Only an administrator can change the administrators email',
    updateUserError: 'Error',
    notAllFieldsFilledOrPasswordShort: 'Not all fields are filled, or the password is too short',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    passwordHint: 'In English letters without spaces',
    rolesAndPermissions: 'Roles and permissions',
    userLoginHint: 'After saving, the employee can log into the app with the specified email and password on the authorization screen',
    changePasswordHint: 'The employee can change the password after saving - to do this, select Forgot password on the authorization screen',
    changePassword: 'Change password',
    newPassword: 'New password',
  },
  permissions: {
    NewSale: 'New sale', applyDiscount: 'Apply discounts', newSaleWithoutShift: 'Make sales without opening a shift', sellCustomProducts: 'Sell custom products',
    newSaleSettings: 'Change settings in New Sale', sellOutOfStockProducts: 'Sell out of stock products',
    SalesHistory: 'Sales history', deleteSale: 'Delete sale', 
    Supplies: 'Supply history', deleteSupply: 'Delete supply', 
    WriteOffs: 'Write-off history', deleteWriteOff: 'Delete write-off', 
    Spendings: 'Expenses', deleteSpending: 'Delete expense', viewAdminSpendingCategories: 'View admin spending categories',
    Revisions: 'Revisions', deleteRevision: 'Delete revision',
    Transfers: 'Transfers of goods', deleteTransfer: 'Delete transfer',
    Manufactures: 'Manufacturing', deleteManufacture: 'Delete manufacturing',
    ComplexSales: 'Complex sales', deleteComplexSale: 'Delete complex sales', editComplexSaleTemplates: 'Edit complex sale templates',
    Payments: 'Payments',
    Products: 'Products', deleteProduct: 'Delete product', viewInactiveProducts: 'View inactive products',
    ProductStocks: 'Product stocks', 
    Clients: 'Clients', ClientDetail: 'Client card', deleteClient: 'Delete client',
    MarketingLists: 'Mailings', 
    PrintStickers: 'Print stickers',
    Updates: 'Updates',
    ClientOrders: 'Client orders',
    Checklist: 'Checklist', editChecklistItems: 'Edit checklist', 
    Shift: 'Shift', changeOthersWorkingHours: 'Edit employees in shift / working hours of others', editShiftStats: 'Edit data in shift', 
    Salary: 'Salary', viewOthersWorkingHours: 'View salaries of other employees', 
    Stats: 'Reports', mainScreenStats: 'View sales stats on main screen',
    Settings: 'Settings', editProductCategories: 'Product categories', editSuppliers: 'Suppliers', editSettings: 'Edit settings',
    editUsers: 'Edit users', 
    viewOtherStores: 'View other branches',
    changeStore: 'Change branch',
    billing: 'Pricing and Billing',
    exportImport: 'Export/Import',
  },
  languages: {
    en: 'English',
    ru: 'Russian',
  },
  currencies: {
    aed: "UAE dirham",
    afn: "Afghani",
    all: "Albanian lek",
    amd: "Armenian dram",
    ang: "Netherlands Antillean guilder",
    aoa: "Angolan kwanza",
    ars: "Argentine peso",
    aud: "Australian dollar",
    awg: "Aruban florin",
    azn: "Azerbaijani manat",
    bam: "Bosnia and Herzegovina convertible mark",
    bbd: "Barbadian dollar",
    bdt: "Bangladeshi taka",
    bgn: "Bulgarian lev",
    bhd: "Bahraini dinar",
    bif: "Burundian franc",
    bmd: "Bermudian dollar",
    bnd: "Brunei dollar",
    bob: "Bolivian boliviano",
    brl: "Brazilian real",
    bsd: "Bahamian dollar",
    btn: "Bhutanese ngultrum",
    bwp: "Botswana pula",
    byn: "Belarusian ruble",
    bzd: "Belize dollar",
    cad: "Canadian dollar",
    cdf: "Congolese franc",
    chf: "Swiss franc",
    clp: "Chilean peso",
    cny: "Chinese yuan",
    cop: "Colombian peso",
    crc: "Costa Rican colón",
    cuc: "Cuban convertible peso",
    cup: "Cuban peso",
    cve: "Cape Verdean escudo",
    czk: "Czech koruna",
    djf: "Djiboutian franc",
    dkk: "Danish krone",
    dop: "Dominican peso",
    dzd: "Algerian dinar",
    egp: "Egyptian pound",
    ern: "Eritrean nakfa",
    etb: "Ethiopian birr",
    eur: "Euro",
    fjd: "Fijian dollar",
    fkp: "Falkland Islands pound",
    gbp: "British pound sterling",
    gel: "Georgian lari",
    ghs: "Ghanaian cedi",
    gip: "Gibraltar pound",
    gmd: "Gambian dalasi",
    gnf: "Guinean franc",
    gtq: "Guatemalan quetzal",
    gyd: "Guyanese dollar",
    hkd: "Hong Kong dollar",
    hnl: "Honduran lempira",
    hrk: "Croatian kuna",
    htg: "Haitian gourde",
    huf: "Hungarian forint",
    idr: "Indonesian rupiah",
    ils: "Israeli new shekel",
    inr: "Indian rupee",
    iqd: "Iraqi dinar",
    irr: "Iranian rial",
    isk: "Icelandic króna",
    jmd: "Jamaican dollar",
    jod: "Jordanian dinar",
    jpy: "Japanese yen",
    kes: "Kenyan shilling",
    kgs: "Kyrgyzstani som",
    khr: "Cambodian riel",
    kmf: "Comorian franc",
    kpw: "North Korean won",
    krw: "South Korean won",
    kwd: "Kuwaiti dinar",
    kyd: "Cayman Islands dollar",
    kzt: "Kazakhstani tenge",
    lak: "Lao kip",
    lbp: "Lebanese pound",
    lkr: "Sri Lankan rupee",
    lrd: "Liberian dollar",
    lsl: "Lesotho loti",
    lyd: "Libyan dinar",
    mad: "Moroccan dirham",
    mdl: "Moldovan leu",
    mga: "Malagasy ariary",
    mkd: "Macedonian denar",
    mmk: "Myanmar kyat",
    mnt: "Mongolian tögrög",
    mop: "Macanese pataca",
    mru: "Mauritanian ouguiya",
    mur: "Mauritian rupee",
    mvr: "Maldivian rufiyaa",
    mwk: "Malawian kwacha",
    mxn: "Mexican peso",
    myr: "Malaysian ringgit",
    mzn: "Mozambican metical",
    nad: "Namibian dollar",
    ngn: "Nigerian naira",
    nio: "Nicaraguan córdoba",
    nok: "Norwegian krone",
    npr: "Nepalese rupee",
    nzd: "New Zealand dollar",
    omr: "Omani rial",
    pab: "Panamanian balboa",
    pen: "Peruvian sol",
    pgk: "Papua New Guinean kina",
    rub: "Russian ruble",
    try: "Turkish lira",
    uah: "Ukrainian hryvnia",
    usd: "United States dollar",
    uzs: "Uzbekistani som"
  },
  invoice: {
    sale: 'Sale',
    from: 'from',
    year: '',
    supplier: 'Supplier',
    buyer: 'Buyer',
    clientPhone: 'Client phone',
    clientAddress: 'Client address',
    deliveryAddress: 'Delivery address',
    itemNumber: '№',
    itemName: 'Item',
    unit: 'Unit',
    quantity: 'Qty',
    price: 'Price',
    amount: 'Amount',
    productImage: 'Image',
    total: 'Total',
    vat: 'VAT',
    totalWithVat: 'Total with VAT',
    withoutTax: 'Without tax (VAT)',
    shippedAmount: 'Shipped for amount',
    totalItems: 'Total items',
    onAmount: 'for amount',
    released: 'Left signature',
    received: 'Right signature'
  },
  blockedScreen: {
    title: 'Update Required',
    message: 'A new version is available. Please update to continue using the app.',
    hint: 'Tap the button below to download and install the update.',
    currentVersion: 'Current version',
    requiredVersion: 'Required version',
    checkForUpdate: 'Update Now',
    checking: 'Updating...',
    noUpdateAvailable: 'Automatic update is not available for your version. Please install the new version from the App Store / Play Market — button below.',
    updateFailed: 'Update failed. Please try again.',
    contactSupport: 'Contact Support',
    openAppStore: 'Install from App Store',
    openPlayStore: 'Install from Play Market',
    softTitle: 'Update Available',
    softMessage: 'A new version is available. Please update to keep working without restrictions.',
    softDismiss: 'Later',
    softUpdate: 'Update',
    bundleIdentity: 'Build',
    restartHint: 'If the app has not restarted, close it and open it again.',
    bundleTitle: 'Updating the app',
    bundleMessage: 'Downloading a required update. This usually takes a few seconds, and the app will restart by itself.'
  },
  outboxV2: {
    unsynced: 'Operations not synced: {{count}}. They are saved on this device and will be sent automatically.',
    unsyncedFailing: 'Operations not synced: {{count}}. Sending has been failing for over an hour — contact support and do not uninstall the app.',
    unsyncedStopped: 'Operations not synced: {{count}}. Syncing has stopped — contact support and do not uninstall the app.',
  },
  whatsapp: {
    noPhone: 'No phone number — there is nothing to open in WhatsApp',
    openFailed: 'Could not open WhatsApp. Check the number and that WhatsApp is installed.'
  }
}}
